import {
  MMMDDYYYY,
  // MMMDDYYYY,
  sanitizeCurrency,
  sanitizePercentage
} from "../../utils/formatChecks";
import {
  accuralTypeDropDown,
  loanPurposeDropDown,
  loanStructureDropDown,
  prepaymentPenaltyTypeDropDown,
  rateType,
  thirtyYearLoanPurpose,
  yOrNDropDown,
  thirtyYearPropertyTypeDropDown,
  foreignNationalOptions,
  yesNoDropdown,
  toorakProductDropDown,
  // thirtyYearToorakProduct,
  propertyTypeDropDown,
  USStates,
  armIndexTypes,
  valuationSourceList,
  bridgeEntityTypeValues, entityTypeValues,
  multiFamMixedUsePropertyTypeDropDown,
  armTypeOptions,
  dscrArmIndexTypes
} from "../constants/loanCreationDropDownValues";

export const BridgeLoanFields = [
  {
    label: "ARM Index",
    path: "loanEconomics.armIndex",
    field: "armIndex",
    type: "dropdown",
    values: armIndexTypes,
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Arm Margin (%)",
    path: "loanEconomics.grossArmMargin",
    field: "grossArmMargin",
    type: "percentage",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  // {
  //   label: "Arm Rounding Factor",
  //   path: "loanEconomics.armRoundingFactor",
  //   field: "armRoundingFactor",
  //   type: "Number",
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //     return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  {
    label: "Initial Rate Adjustment Period",
    path: "loanEconomics.initialRateAdjustmentPeriod",
    field: "initialRateAdjustmentPeriod",
    type: "number",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Initial Pay Adjustment Period",
    path: "loanEconomics.initialPayAdjustmentPeriod",
    field: "initialPayAdjustmentPeriod",
    type: "number",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Initial Periodic Cap (%)",
    path: "loanEconomics.initialPeriodicCap",
    field: "initialPeriodicCap",
    type: "percentage",
    disableAfterApproved: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  // {
  //   label: "Initial Periodic Cap (Change Up) (%)",
  //   path: "loanEconomics.initialInterestRateUp",
  //   field: "initialInterestRateUp",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //     return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "Initial Periodic Cap (Change Down) (%)",
  //   path: "loanEconomics.initialInterestRateDown",
  //   field: "initialInterestRateDown",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //      return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  {
    label: "Subsequent Periodic Cap (%)",
    path: "loanEconomics.subsequentPeriodicCap",
    field: "subsequentPeriodicCap",
    type: "percentage",
    disableAfterApproved: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  // {
  //   label: "Subsequent Periodic Cap (Change Up) (%)",
  //   path: "loanEconomics.subsequentInterestRateUp",
  //   field: "subsequentInterestRateUp",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   hidden: (loanDetails: any, view: string) => {
  //      return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "Subsequent Periodic Cap (Change Down) (%)",
  //   path: "loanEconomics.subsequentInterestRateDown",
  //   field: "subsequentInterestRateDown",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   hidden: (loanDetails: any, view: string) => {
  //      return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "Lifetime Max Rate (%)",
  //   path: "loanEconomics.lifetimeMaxRate",
  //   field: "lifetimeMaxRate",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //     return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "Lifetime Min Rate (%)",
  //   path: "loanEconomics.lifetimeMinRate",
  //   field: "lifetimeMinRate",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   hidden: (loanDetails: any, view: string) => {
  //      return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  {
    label: "Payment Adjustment Frequency",
    path: "loanEconomics.paymentAdjustmentFrequency",
    field: "paymentAdjustmentFrequency",
    type: "Number",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Rate Adjustment Frequency",
    path: "loanEconomics.rateAdjustmentFrequency",
    field: "rateAdjustmentFrequency",
    type: "Number",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  // {
  //   label: "ARM Round Flag",
  //   path: "loanEconomics.armRoundFlag",
  //   field: "armRoundFlag",
  //   type: "dropdown",
  //   values: yesNoDropdown,
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //     return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "ARM Look Back Days",
  //   path: "loanEconomics.armLookBackDays",
  //   field: "armLookBackDays",
  //   type: "number",
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //     return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  {
    label: "Lifetime Cap (%)",
    path: "loanEconomics.lifeRateCap",
    field: "lifeRateCap",
    type: "percentage",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Recourse",
    path: "loanInfo.recourseString",
    auditPath: "loanInfo.recourseString",
    field: "recourseString",
    aliasKey: "selectedRecourse",
    rulesKey: "recourse",
    type: "dropdown",
    disableAfterApproved: true,
    values: ["Full Recourse", "Non-Recourse"],
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  // {
  //   label: "Number Of Properties",
  //   path: "loanInfo.noOfProperties",
  //   field: "noOfProperties",
  //   aliasKey: "numberOfProperties",
  //   rulesKey: "noOfProperties",
  //   type: "number",
  //   disableAfterApproved: true
  // },
  // {
  //   label: "Cut-off Date",
  //   path: "loanInfo.cutOffDate",
  //   field: "cutOffDate",
  //   type: "dateOnly"
  // },
  {
    label: "Toorak Product",
    path: "loanInfo.toorakProduct",
    field: "toorakProduct",
    aliasKey: "selectedToorakProduct",
    rulesKey: "toorakProduct",
    type: "dropdown",
    values: toorakProductDropDown
  },
  {
    label: "Cut-off Date Loan Amount ($)",
    path: "loanEconomics.cutOffDateLoanAmount",
    field: "cutOffDateLoanAmount",
    aliasKey: "cutOffLoanAmount",
    rulesKey: "cutOffDateLoanAmount",
    disableAfterApproved: true,
    type: "currency"
  },
  {
    label: "Cut-off Date Maximum Amount ($)",
    path: "loanEconomics.cutOffDateMaximumLoanAmount",
    field: "cutOffDateMaximumLoanAmount",
    aliasKey: "cutOffMaxLoanAmount",
    rulesKey: "cutOffDateMaximumLoanAmount",
    disableAfterApproved: true,
    type: "currency"
  },
  // {
  //   label: "Insurance + Amortization ($)",
  //   path: "loanEconomics.insuranceAndAmortization",
  //   field: "insuranceAndAmortization",
  //   type: "currency"
  // },
  // {
  //   label: "Insurance ($)",
  //   path: "loanDetailId.loanSummaryId.insurance",
  //   field: "insurance",
  //   type: "currency",
  //   skipRules: true
  // },
  {
    label: "Loan Structure",
    path: "loanInfo.loanStructure",
    field: "loanStructure",
    aliasKey: "selectedLoanStructure",
    rulesKey: "loanStructure",
    type: "dropdown",
    disableAfterApproved: true,
    values: loanStructureDropDown
  },
  {
    label: "Loan Purpose",
    path: "loanInfo.loanPurpose",
    field: "loanPurpose",
    type: "dropdown",
    disableAfterApproved: true,
    values: loanPurposeDropDown
  },
  {
    label: "Total Budget Amount ($)",
    path: "loanEconomics.totalBudgetAmount",
    field: "totalBudgetAmount",
    aliasKey: "budgetAmount",
    rulesKey: "totalBudgetAmount",
    disableAfterApproved: true,
    type: "currency"
  },
  {
    label: "Financed Interest Reserve ($)",
    path: "loanEconomics.financedInterestReserve",
    field: "financedInterestReserve",
    aliasKey: "financialInterestReserve",
    rulesKey: "financedInterestReserve",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Original Loan Amount ($)",
    path: "loanEconomics.originalLoanAmount",
    field: "originalLoanAmount",
    aliasKey: "loanAmount",
    rulesKey: "originalLoanAmount",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Rate Type",
    path: "loanEconomics.rateType",
    field: "rateType",
    type: "dropdown",
    disableAfterApproved: true,
    values: rateType
  },
  {
    label: "Original Maximum Loan Amount ($)",
    path: "loanEconomics.originalMaximumLoanAmount",
    field: "originalMaximumLoanAmount",
    aliasKey: "maxLoanAmount",
    rulesKey: "originalMaximumLoanAmount",
    disableAfterApproved: true,
    type: "currency"
  },
  {
    label: "Interest Rate (As of Cut off Date) (%)",
    path: "loanEconomics.interestRateAsOfCutOffDate",
    field: "interestRateAsOfCutOffDate",
    aliasKey: "interestRate",
    type: "percentage",
    disableAfterApproved: true
  },
  {
    label: "Accrual Type",
    path: "loanEconomics.accrualType",
    field: "accrualType",
    type: "dropdown",
    disableAfterApproved: true,
    values: accuralTypeDropDown
    // hidden: (loanDetails: any, view: string) => {
    //   return view === "reconcile";
    // }
  },
  {
    label: "Origination Date",
    path: "loanInfo.originationDate",
    field: "originationDate",
    type: "date",
    disableAfterApproved: true
  },
  {
    label: "First Payment Date",
    path: "loanInfo.firstPaymentDateOfLoan",
    field: "firstPaymentDateOfLoan",
    aliasKey: "firstPaymentDate",
    rulesKey: "firstPaymentDateOfLoan",
    disableAfterApproved: true,
    type: "date"
  },
  {
    label: "Cash Out Amount ($)",
    path: "loanEconomics.cashOutAmount",
    field: "cashOutAmount",
    disableAfterApproved: true,
    type: "currency"
  },
  {
    label: "Extension Option (Months)",
    path: "loanInfo.extensionOptions",
    field: "extensionOptions",
    aliasKey: "extensionOption",
    rulesKey: "extensionOptions",
    disableAfterApproved: true,
    type: "number"
  },
  {
    label: "Default Rate (%)",
    path: "loanInfo.defaultRate",
    field: "defaultRate",
    disableAfterApproved: true,
    type: "percentage"
  },
  {
    label: "Default Interest Rate Type",
    path: "loanEconomics.defaultInterestRateType",
    field: "defaultInterestRateType",
    type: "dropdown",
    disableAfterApproved: true,
    values: ["Fixed", "Increasing"],
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Default Rate Curable (Grace Days)",
    path: "loanInfo.defaultRateCurable",
    field: "defaultRateCurable",
    disableAfterApproved: true,
    type: "number",
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Insurance Agent First Name",
    path: "loanDetailId.loanSummaryId.insuranceAgentFirstName",
    field: "insuranceAgentFirstName",
    type: "text",
    skipRules: true
  },
  {
    label: "Insurance Agent Last Name",
    path: "loanDetailId.loanSummaryId.insuranceAgentLastName",
    field: "insuranceAgentLastName",
    type: "text",
    skipRules: true
  },
  {
    label: "Insurance Agent Email",
    path: "loanDetailId.loanSummaryId.insuranceAgentEmail",
    field: "insuranceAgentEmail",
    type: "email",
    skipRules: true
  },
  {
    label: "Insurance Agent Contact Number",
    path: "loanDetailId.loanSummaryId.insuranceAgentContactNumber",
    field: "insuranceAgentContactNumber",
    type: "phone",
    skipRules: true
  },
  {
    label: "Insurance Expiration Date",
    path: "loanDetailId.loanSummaryId.insuranceExpirationDate",
    field: "insuranceExpirationDate",
    type: "dateOnly",
    skipRules: true
  },
  {
    label: "Insurance Company",
    path: "loanDetailId.loanSummaryId.insuranceCompany",
    field: "insuranceCompany",
    type: "text",
    skipRules: true
  },
  {
    label: "Insurance Type",
    path: "loanDetailId.loanSummaryId.insuranceType",
    field: "insuranceType",
    type: "text",
    disableAfterApproved: true
  },
  {
    label: "Insurance Company Address",
    path: "loanDetailId.loanSummaryId.insuranceCompanyAddress",
    field: "insuranceCompanyAddress",
    type: "billingaddress",
    skipRules: true
  },
  {
    label: "Policy Number",
    path: "loanDetailId.loanSummaryId.policyNumber",
    field: "policyNumber",
    type: "text",
    skipRules: true
  },
  {
    label: "Frequency",
    path: "loanDetailId.loanSummaryId.frequency",
    field: "frequency",
    disableAfterApproved: true,
    type: "dropdown",
    values: ["Monthly", "Quarterly", "Half-yearly", "Yearly"],
    skipRules: true
  },
  {
    label: "Responsibility",
    path: "loanDetailId.loanSummaryId.responsibility",
    field: "responsibility",
    type: "dropdown",
    values: ["Escrowed", "Borrower"],
    skipRules: true
  },
  // {
  //   label: "Annual Property Taxes for All ($)",
  //   path: "loanDetailId.loanSummaryId.taxes",
  //   field: "taxes",
  //   type: "currency",
  //   skipRules: true
  // },
  {
    label: "Interest Only",
    path: "loanEconomics.interestOnly",
    field: "interestOnly",
    type: "dropdown",
    disableAfterApproved: true,
    values: yOrNDropDown
  },
  {
    label: "Late Charge ($)",
    path: "loanEconomics.lateCharge",
    field: "lateCharge",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Late Charge (%)",
    path: "loanEconomics.lateChargePercentage",
    field: "lateChargePercentage",
    type: "percentage",
    disableAfterApproved: true
  },
  {
    label: "Interest Payment ($)",
    path: "loanEconomics.originalMonthlyPiPayment",
    field: "originalMonthlyPiPayment",
    type: "currency",
    disableAfterApproved: true,
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Gross Amount Due from Borrower ($)",
    path: "loanEconomics.grossAmountDueFromBorrowerHUD",
    field: "grossAmountDueFromBorrowerHUD",
    disableAfterApproved: true,
    type: "currency"
  },
  {
    label: "Origination Fee ($)",
    path: "loanFees.originationFeeHUD",
    field: "originationFeeHUD",
    type: "currency",
    disableAfterApproved: true,
    // hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Broker Fee ($)",
    path: "loanFees.brokerFeeHUD",
    field: "brokerFeeHUD",
    type: "currency"
  },
  {
    label: "Assignment Fee ($)",
    path: "loanFees.assignmentFeeHUD",
    field: "assignmentFeeHUD",
    type: "currency",
    skipRules: true
  },
  {
    label: "Per Diem Interest ($)",
    path: "loanFees.perDiemInterestHUD",
    field: "perDiemInterestHUD",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Flood Insurance Coverage ($)",
    path: "loanEconomics.floodInsuranceCoverage",
    field: "floodInsuranceCoverage",
    disableAfterApproved: true,
    type: "currency"
  },
  {
    label: "HOI Dwelling Coverage ($)",
    path: "loanEconomics.hoiDwellingCoverage",
    field: "hoiDwellingCoverage",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "ACH Activation Type",
    path: "achData.achActivationType",
    field: "achActivationType",
    type: "text",
    skipRules: true
  },
  {
    label: "Bank ABA Routing Number",
    path: "achData.bankABARoutingNumber",
    field: "bankABARoutingNumber",
    type: "abaroutingnumber",
    skipRules: true
  },
  {
    label: "Bank Name",
    path: "achData.bankName",
    field: "bankName",
    type: "text",
    skipRules: true
  },
  {
    label: "Bank City",
    path: "achData.bankCity",
    field: "bankCity",
    type: "text",
    skipRules: true
  },
  {
    label: "Bank State",
    path: "achData.bankState",
    field: "bankState",
    type: "dropdown",
    values: USStates,
    skipRules: true
  },
  {
    label: "Bank Account Number",
    path: "achData.bankAccountNumber",
    field: "bankAccountNumber",
    type: "Number",
    skipRules: true
  },
  {
    label: "Bank Account Type",
    path: "achData.bankAccountType",
    field: "bankAccountType",
    type: "dropdown",
    values: ["Savings Account", "Checking Account"],
    skipRules: true
  },
  {
    label: "PreNote",
    path: "achData.preNote",
    field: "preNote",
    type: "text",
    skipRules: true
  },
  {
    label: "Name on Account Indicator",
    path: "achData.nameOnAccountIndicator",
    field: "nameOnAccountIndicator",
    type: "dropdown",
    values: ["B", "C", "3"],
    skipRules: true
  },
  {
    label: "Drafting Option",
    path: "achData.draftingOption",
    field: "draftingOption",
    type: "dropdown",
    values: ["Monthly", "Bi-Weekly", "Weekly", "Semi-Monthly"],
    skipRules: true
  },
  {
    label: "Draft Day 1",
    path: "achData.draftDay1",
    field: "draftDay1",
    type: "dateOnly",
    skipRules: true
  },
  {
    label: "Draft Day 2",
    path: "achData.draftDay2",
    field: "draftDay2",
    type: "dateOnly",
    skipRules: true
  },
  {
    label: "ACH Start Date",
    path: "achData.desiredStartDate",
    field: "desiredStartDate",
    type: "dateOnly",
    skipRules: true
  },
  {
    label: "Additional Principal",
    path: "achData.additionalPrincipal",
    field: "additionalPrincipal",
    type: "currency",
    skipRules: true
  },
  {
    label: "Additional Escrow",
    path: "achData.additionalEscrow",
    field: "additionalEscrow",
    type: "currency",
    skipRules: true
  },
  {
    label: "Additional Other",
    path: "achData.additionalOther",
    field: "additionalOther",
    type: "currency",
    skipRules: true
  },
  {
    label: "Draft Fee",
    path: "achData.draftFee",
    field: "draftFee",
    type: "currency",
    skipRules: true
  },
  {
    label: "Fixed Draft Amount",
    path: "achData.fixedDraftAmount",
    field: "fixedDraftAmount",
    type: "currency",
    skipRules: true
  },
  {
    label: "Next Transfer Date",
    path: "achData.nextTransferDate",
    field: "nextTransferDate",
    type: "dateOnly",
    skipRules: true
  },
  {
    label: "Last Draft Date",
    path: "achData.lastDraftDate",
    field: "lastDraftDate",
    type: "dateOnly",
    disableAfterApproved: true,
    skipRules: true
  },
  {
    label: "FPL - Monthly P&I",
    path: "loanEconomics.fplMonthlyPI",
    field: "fplMonthlyPI",
    type: "currency",
    skipRules: true
  },
  {
    label: "FPL - Monthly Total Payment",
    path: "loanEconomics.fplMonthlyTotalPayment",
    field: "fplMonthlyTotalPayment",
    type: "currency",
    skipRules: true
  },
  {
    label: "Origination Points (%)",
    path: "loanDetailId.originationPointPercentage",
    field: "originationPointPercentage",
    type: "nonEditable",
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Discount Points (%)",
    path: "loanDetailId.discountPointPercentage",
    field: "discountPointPercentage",
    type: "nonEditable",
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Original Maturity Date",
    path: "loanInfo.originalMaturityDate",
    field: "originalMaturityDate",
    disableAfterApproved: true,
    type: "dateOnly"
  },
  {
    label: "Current Maturity Date",
    path: "loanInfo.currentMaturityDate",
    field: "currentMaturityDate",
    type: "dateOnly"
  },
  {
    label: "Borrower Liquidity ($)",
    path: "loanEconomics.borrowerLiquidity",
    field: "borrowerLiquidity",
    type: "currency",
    skipRules: true,
    // hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Down Payment Reserve ($)",
    path: "loanEconomics.downPaymentReserve",
    field: "downPaymentReserve",
    type: "currency",
    skipRules: true
  },
  {
    label: "Discount Points ($)",
    path: "loanDetailId.discountPointAmount",
    field: "discountPointAmount",
    type: "currency",
    skipRules: true,
    // hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Max Interest Payment ($)",
    path: "loanResults.loanResult.[loanId].loanEconomics.maxInterestPayment",
    ttfInfoPath: "results.loanResult.[loanId].loanEconomics.maxInterestPayment",
    field: "maxInterestPayment",
    type: "nonEditable",
    skipRules: true,
    outputDataMadeInput: true
  }
];

export const DSCRLoanFields = [
  {
    label: "ARM Index",
    path: "loanEconomics.armIndex",
    field: "armIndex",
    type: "dropdown",
    values: dscrArmIndexTypes,
    skipRules: true,
    // hidden: (loanDetails: any, view: string) =>
    //   loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Arm Margin (%)",
    path: "loanResults.loanResult.[loanId].loanPricing.grossArmMargin",
    ttfInfoPath:
      "results.assignedTpResult.loanResult.[loanId].loanPricing.grossArmMargin",
    field: "grossArmMargin",
    type: "percentage",
    skipRules: true,
    isMultiplyBy100: true,
    // hidden: (loanDetails: any, view: string) =>
    //   loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  // {
  //   label: "Arm Rounding Factor",
  //   path: "loanEconomics.armRoundingFactor",
  //   field: "armRoundingFactor",
  //   type: "Number",
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //     return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "Initial Rate Adjustment Period",
  //   path: "loanEconomics.initialRateAdjustmentPeriod",
  //   field: "initialRateAdjustmentPeriod",
  //   type: "number",
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) =>
  //     loanDetails?.loanEconomics?.rateType !== "Adjustable"
  // },
  // {
  //   label: "Initial Pay Adjustment Period",
  //   path: "loanEconomics.initialPayAdjustmentPeriod",
  //   field: "initialPayAdjustmentPeriod",
  //   type: "number",
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) =>
  //     loanDetails?.loanEconomics?.rateType !== "Adjustable"
  // },
  {
    label: "Initial Cap (%)",
    path: "loanResults.loanResult.[loanId].loanPricing.initialPeriodicCap",
    ttfInfoPath:
      "results.assignedTpResult.loanResult.[loanId].loanPricing.initialPeriodicCap",
    field: "initialPeriodicCap",
    type: "percentage",
    disableAfterApproved: true,
    isMultiplyBy100: true,
    // hidden: (loanDetails: any, view: string) =>
      // loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  // {
  //   label: "Initial Periodic Cap (Change Up) (%)",
  //   path: "loanEconomics.initialInterestRateUp",
  //   field: "initialInterestRateUp",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //     return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "Initial Periodic Cap (Change Down) (%)",
  //   path: "loanEconomics.initialInterestRateDown",
  //   field: "initialInterestRateDown",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //      return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  {
    label: "Periodic Cap (%)",
    path: "loanResults.loanResult.[loanId].loanPricing.subsequentPeriodicCap",
    ttfInfoPath:
      "results.assignedTpResult.loanResult.[loanId].loanPricing.subsequentPeriodicCap",
    field: "subsequentPeriodicCap",
    type: "percentage",
    disableAfterApproved: true,
    isMultiplyBy100: true,
    // hidden: (loanDetails: any, view: string) =>
    //   loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  // {
  //   label: "Subsequent Periodic Cap (Change Up) (%)",
  //   path: "loanEconomics.subsequentInterestRateUp",
  //   field: "subsequentInterestRateUp",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   hidden: (loanDetails: any, view: string) => {
  //      return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "Subsequent Periodic Cap (Change Down) (%)",
  //   path: "loanEconomics.subsequentInterestRateDown",
  //   field: "subsequentInterestRateDown",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   hidden: (loanDetails: any, view: string) => {
  //      return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "Lifetime Max Rate (%)",
  //   path: "loanEconomics.lifetimeMaxRate",
  //   field: "lifetimeMaxRate",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //     return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "Lifetime Min Rate (%)",
  //   path: "loanEconomics.lifetimeMinRate",
  //   field: "lifetimeMinRate",
  //   type: "percentage",
  //   disableAfterApproved: true,
  //   hidden: (loanDetails: any, view: string) => {
  //      return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "Payment Adjustment Frequency",
  //   path: "loanEconomics.paymentAdjustmentFrequency",
  //   field: "paymentAdjustmentFrequency",
  //   type: "Number",
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) =>
  //     loanDetails?.loanEconomics?.rateType !== "Adjustable"
  // },
  // {
  //   label: "Rate Adjustment Frequency",
  //   path: "loanEconomics.rateAdjustmentFrequency",
  //   field: "rateAdjustmentFrequency",
  //   type: "Number",
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) =>
  //     loanDetails?.loanEconomics?.rateType !== "Adjustable"
  // },
  // {
  //   label: "ARM Round Flag",
  //   path: "loanEconomics.armRoundFlag",
  //   field: "armRoundFlag",
  //   type: "dropdown",
  //   values: yesNoDropdown,
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //     return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  // {
  //   label: "ARM Look Back Days",
  //   path: "loanEconomics.armLookBackDays",
  //   field: "armLookBackDays",
  //   type: "number",
  //   skipRules: true,
  //   hidden: (loanDetails: any, view: string) => {
  //     return loanDetails?.loanEconomics?.rateType !== "Adjustable";
  //   }
  // },
  {
    label: "Lifetime Cap (%)",
    path: "loanResults.loanResult.[loanId].loanPricing.lifeTimeCap",
    field: "lifeTimeCap",
    type: "percentage",
    skipRules: true,
    isMultiplyBy100: true,
    // hidden: (loanDetails: any, view: string) =>
    //   loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Recourse",
    path: "loanInfo.recourseString",
    auditPath: "loanInfo.recourse",
    field: "recourseString",
    aliasKey: "selectedRecourse",
    rulesKey: "recourse",
    type: "dropdown",
    disableAfterApproved: true,
    values: ["Full Recourse", "Non-Recourse"],
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  // {
  //   label: "Cut Off Date",
  //   path: "loanInfo.cutOffDate",
  //   field: "cutOffDate",
  //   type: "dateOnly"
  // },
  // {
  //   label: "Toorak Product",
  //   path: "loanInfo.toorakProduct",
  //   field: "toorakProduct",
  //   aliasKey: "selectedToorakProduct",
  //   rulesKey: "toorakProduct",
  //   type: "dropdown",
  //   values: thirtyYearToorakProduct
  // },
  {
    label: "Number Of Properties",
    path: "loanInfo.noOfProperties",
    field: "noOfProperties",
    aliasKey: "numberOfProperties",
    rulesKey: "noOfProperties",
    type: "number",
    disableAfterApproved: true
  },
  {
    label: "Cross Collaterlization (Y/N)",
    path: "loanInfo.crossCollaterlization",
    field: "crossCollaterlization",
    aliasKey: "selectedCross",
    rulesKey: "crossCollaterlization",
    disableAfterApproved: true,
    type: "dropdown",
    values: yOrNDropDown
  },
  {
    label: "Loan Purpose",
    path: "loanInfo.loanPurpose",
    field: "loanPurpose",
    type: "dropdown",
    disableAfterApproved: true,
    values: thirtyYearLoanPurpose
  },
  {
    label: "Condo Eligibility",
    path: "loanInfo.condoEligibility",
    field: "condoEligibility",
    type: "dropdown",
    disableAfterApproved: true,
    values: [] // assigned dynamically
  },
  {
    label: "Financed Interest Reserve ($)",
    path: "loanEconomics.financedInterestReserve",
    field: "financedInterestReserve",
    aliasKey: "financialInterestReserve",
    rulesKey: "financedInterestReserve",
    disableAfterApproved: true,
    type: "currency"
  },
  {
    label: "Original Loan Amount ($)",
    path: "loanEconomics.originalLoanAmount",
    field: "originalLoanAmount",
    aliasKey: "loanAmount",
    rulesKey: "originalLoanAmount",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Current Loan Balance ($)",
    path: "loanEconomics.currentLoanBalance",
    field: "currentLoanBalance",
    type: "currency",
    disableAfterApproved: true,
    auditPath:"[loanId].loanEconomics.currentLoanBalanceAmount"
  },
  {
    label: "Interest Only Period",
    path: "loanEconomics.interestOnlyPeriod",
    field: "interestOnlyPeriod",
    type: "number",
    disableAfterApproved: true
  },
  {
    label: "Prepay Penalties Type",
    path: "loanEconomics.prepayPenaltyType",
    field: "prepayPenaltyType",
    type: "dropdown",
    disableAfterApproved: true,
    values: prepaymentPenaltyTypeDropDown
  },
  {
    label: "Rate Type",
    path: "loanEconomics.rateType",
    field: "rateType",
    type: "dropdown",
    disableAfterApproved: true,
    values: rateType
  },
  {
    label: "Interest Rate (As of Cut off Date) (%)",
    path: "loanEconomics.interestRateAsOfCutOffDate",
    field: "interestRateAsOfCutOffDate",
    aliasKey: "interestRate",
    type: "percentage",
    disableAfterApproved: true
  },
  {
    label: "Origination Date",
    path: "loanInfo.originationDate",
    field: "originationDate",
    type: "date",
    disableAfterApproved: true
  },
  {
    label: "First Payment Date",
    path: "loanInfo.firstPaymentDateOfLoan",
    field: "firstPaymentDateOfLoan",
    aliasKey: "firstPaymentDate",
    rulesKey: "firstPaymentDateOfLoan",
    disableAfterApproved: true,
    type: "date"
  },
  {
    label: "Last Payment Date",
    path: "loanDetailId.loanSummaryId.lastPaymentDate",
    field: "lastPaymentDate",
    type: "date",
    disableAfterApproved: true
  },
  {
    label: "Original Maturity Date",
    path: "loanInfo.originalMaturityDate",
    field: "originalMaturityDate",
    type: "dateOnly"
  },
  {
    label: "Cash Out Amount ($)",
    path: "loanEconomics.cashOutAmount",
    field: "cashOutAmount",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Default Rate (%)",
    path: "loanInfo.defaultRate",
    field: "defaultRate",
    type: "percentage",
    disableAfterApproved: true
  },
  {
    label: "Default Interest Rate Type",
    path: "loanEconomics.defaultInterestRateType",
    field: "defaultInterestRateType",
    type: "dropdown",
    disableAfterApproved: true,
    values: ["Fixed", "Increasing"],
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Default Rate Curable (Grace Days)",
    path: "loanInfo.defaultRateCurable",
    field: "defaultRateCurable",
    disableAfterApproved: true,
    type: "number",
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Prepayment Penalty Total Term (Months)",
    path: "loanEconomics.prepaymentPenaltyMonths",
    field: "prepaymentPenaltyMonths",
    type: "number"
  },
  // {
  //   label: "Borrower is LLC",
  //   path: "loanEconomics.borrowerIsLLC",
  //   field: "borrowerIsLLC",
  //   type: "dropdown",
  //   values: yOrNDropDown,
  //   skipRules: true
  // },
  // {
  //   label: "HOA Payment Frequency",
  //   path: "loanEconomics.hoaPaymentFrequency",
  //   field: "hoaPaymentFrequency",
  //   type: "text",
  //   skipRules: true
  // },
  {
    label: "Borrower Liquidity ($)",
    path: "loanEconomics.borrowerLiquidity",
    field: "borrowerLiquidity",
    disableAfterApproved: true,
    type: "currency",
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Escrow Taxes at Closing ($)",
    path: "loanDetailId.loanSummaryId.escrowTaxes",
    field: "escrowTaxes",
    type: "readOnly"
  },
  {
    label: "Escrow Insurance at Closing ($)",
    path: "loanDetailId.loanSummaryId.escrowInsurance",
    field: "escrowInsurance",
    type: "readOnly"
  },
  {
    label: "Accrual Type",
    path: "loanEconomics.accrualType",
    field: "accrualType",
    type: "dropdown",
    disableAfterApproved: true,
    values: accuralTypeDropDown,
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Subordinate Financing",
    path: "loanEconomics.subordinateFinancing",
    field: "subordinateFinancing",
    rulesKey: "subOrdinateFinancing",
    type: "yesnodropdown",
    disableAfterApproved: true,
    values: yesNoDropdown
  },
  {
    label: "Business Purpose Occupancy",
    path: "loanEconomics.businessPurposeOccupancy",
    field: "businessPurposeOccupancy",
    type: "yesnodropdown",
    disableAfterApproved: true,
    values: yesNoDropdown
  },
  {
    label: "T&I Collected",
    path: "loanDetailId.loanSummaryId.taxesAndInsuranceCollected",
    field: "taxesAndInsuranceCollected",
    type: "dropdown",
    disableAfterApproved: true,
    values: yesNoDropdown
  },
  {
    label: "T&I Due",
    path: "loanDetailId.loanSummaryId.taxesandInsuranceDue",
    field: "taxesandInsuranceDue",
    type: "dropdown",
    disableAfterApproved: true,
    values: yesNoDropdown
  },
  {
    label: "Updated Insurance Escrow Balance ($)",
    path: "loanDetailId.loanSummaryId.updatedInsuranceEscrowBalance",
    field: "updatedInsuranceEscrowBalance",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Updated Tax Escrow Balance ($)",
    path: "loanDetailId.loanSummaryId.updatedTaxEscrowBalance",
    field: "updatedTaxEscrowBalance",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Late Charge ($)",
    path: "loanEconomics.lateCharge",
    field: "lateCharge",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Late Charge (%)",
    path: "loanEconomics.lateChargePercentage",
    field: "lateChargePercentage",
    type: "percentage",
    disableAfterApproved: true
  },
  {
    label: "Insurance Agent First Name",
    path: "loanDetailId.loanSummaryId.insuranceAgentFirstName",
    field: "insuranceAgentFirstName",
    type: "text",
    skipRules: true
  },
  {
    label: "Insurance Agent Last Name",
    path: "loanDetailId.loanSummaryId.insuranceAgentLastName",
    field: "insuranceAgentLastName",
    type: "text",
    skipRules: true
  },
  {
    label: "Insurance Agent Email",
    path: "loanDetailId.loanSummaryId.insuranceAgentEmail",
    field: "insuranceAgentEmail",
    type: "email",
    skipRules: true
  },
  {
    label: "Insurance Agent Contact Number",
    path: "loanDetailId.loanSummaryId.insuranceAgentContactNumber",
    field: "insuranceAgentContactNumber",
    type: "phone",
    skipRules: true
  },
  {
    label: "Insurance Expiration Date",
    path: "loanDetailId.loanSummaryId.insuranceExpirationDate",
    field: "insuranceExpirationDate",
    type: "dateOnly",
    skipRules: true
  },
  {
    label: "Insurance Company",
    path: "loanDetailId.loanSummaryId.insuranceCompany",
    field: "insuranceCompany",
    type: "text",
    skipRules: true
  },
  {
    label: "Insurance Type",
    path: "loanDetailId.loanSummaryId.insuranceType",
    field: "insuranceType",
    type: "text",
    disableAfterApproved: true
  },
  {
    label: "Insurance Company Address",
    path: "loanDetailId.loanSummaryId.insuranceCompanyAddress",
    field: "insuranceCompanyAddress",
    type: "billingaddress",
    skipRules: true
  },
  {
    label: "Policy Number",
    path: "loanDetailId.loanSummaryId.policyNumber",
    field: "policyNumber",
    type: "text",
    skipRules: true
  },
  {
    label: "Frequency",
    path: "loanDetailId.loanSummaryId.frequency",
    field: "frequency",
    disableAfterApproved: true,
    type: "dropdown",
    values: ["Monthly", "Quarterly", "Half-yearly", "Yearly"]
  },
  {
    label: "Responsibility",
    path: "loanDetailId.loanSummaryId.responsibility",
    field: "responsibility",
    type: "dropdown",
    values: ["Escrowed", "Borrower"],
    skipRules: true
  },
  {
    label: "Interest Only",
    path: "loanEconomics.interestOnly",
    field: "interestOnly",
    type: "dropdown",
    disableAfterApproved: true,
    values: yOrNDropDown
  },
  {
    label: "P&I Payment ($)",
    path: "loanEconomics.originalMonthlyPiPayment",
    field: "originalMonthlyPiPayment",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Gross Amount Due from Borrower ($)",
    path: "loanEconomics.grossAmountDueFromBorrowerHUD",
    field: "grossAmountDueFromBorrowerHUD",
    disableAfterApproved: true,
    type: "currency"
  },
  {
    label: "Origination Fee ($)",
    path: "loanFees.originationFeeHUD",
    field: "originationFeeHUD",
    type: "currency",
    disableAfterApproved: true,
    // hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Broker Fee ($)",
    path: "loanFees.brokerFeeHUD",
    field: "brokerFeeHUD",
    type: "currency"
  },
  {
    label: "Assignment Fee ($)",
    path: "loanFees.assignmentFeeHUD",
    field: "assignmentFeeHUD",
    type: "currency"
  },
  {
    label: "Per Diem Interest ($)",
    path: "loanFees.perDiemInterestHUD",
    field: "perDiemInterestHUD",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Flood Insurance Coverage ($)",
    path: "loanEconomics.floodInsuranceCoverage",
    field: "floodInsuranceCoverage",
    disableAfterApproved: true,
    type: "currency"
  },
  {
    label: "HOI Dwelling Coverage ($)",
    path: "loanEconomics.hoiDwellingCoverage",
    field: "hoiDwellingCoverage",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "ACH Activation Type",
    path: "achData.achActivationType",
    field: "achActivationType",
    type: "text",
    skipRules: true
  },
  {
    label: "Bank ABA Routing Number",
    path: "achData.bankABARoutingNumber",
    field: "bankABARoutingNumber",
    type: "abaroutingnumber",
    skipRules: true
  },
  {
    label: "Bank Name",
    path: "achData.bankName",
    field: "bankName",
    type: "text",
    skipRules: true
  },
  {
    label: "Bank City",
    path: "achData.bankCity",
    field: "bankCity",
    type: "text",
    skipRules: true
  },
  {
    label: "Bank State",
    path: "achData.bankState",
    field: "bankState",
    type: "dropdown",
    values: USStates,
    skipRules: true
  },
  {
    label: "Bank Account Number",
    path: "achData.bankAccountNumber",
    field: "bankAccountNumber",
    type: "Number",
    skipRules: true
  },
  {
    label: "Bank Account Type",
    path: "achData.bankAccountType",
    field: "bankAccountType",
    type: "dropdown",
    values: ["Savings Account", "Checking Account"],
    skipRules: true
  },
  {
    label: "PreNote",
    path: "achData.preNote",
    field: "preNote",
    type: "text",
    skipRules: true
  },
  {
    label: "Name on Account Indicator",
    path: "achData.nameOnAccountIndicator",
    field: "nameOnAccountIndicator",
    type: "dropdown",
    values: ["B", "C", "3"],
    skipRules: true
  },
  {
    label: "Drafting Option",
    path: "achData.draftingOption",
    field: "draftingOption",
    type: "dropdown",
    values: ["Monthly", "Bi-Weekly", "Weekly", "Semi-Monthly"],
    skipRules: true
  },
  {
    label: "Draft Day 1",
    path: "achData.draftDay1",
    field: "draftDay1",
    type: "dateOnly",
    skipRules: true
  },
  {
    label: "Draft Day 2",
    path: "achData.draftDay2",
    field: "draftDay2",
    type: "dateOnly",
    skipRules: true
  },
  // {
  //   label: "Desired Start Date",
  //   path: "achData.desiredStartDate",
  //   field: "desiredStartDate",
  //   type: "dateOnly",
  //   skipRules: true
  // },
  {
    label: "Additional Principal",
    path: "achData.additionalPrincipal",
    field: "additionalPrincipal",
    type: "currency",
    skipRules: true
  },
  {
    label: "Additional Escrow",
    path: "achData.additionalEscrow",
    field: "additionalEscrow",
    type: "currency",
    skipRules: true
  },
  {
    label: "Additional Other",
    path: "achData.additionalOther",
    field: "additionalOther",
    type: "currency",
    skipRules: true
  },
  {
    label: "Draft Fee",
    path: "achData.draftFee",
    field: "draftFee",
    type: "currency",
    skipRules: true
  },
  {
    label: "Fixed Draft Amount",
    path: "achData.fixedDraftAmount",
    field: "fixedDraftAmount",
    type: "currency",
    skipRules: true
  },
  {
    label: "Next Transfer Date",
    path: "achData.nextTransferDate",
    field: "nextTransferDate",
    type: "dateOnly",
    skipRules: true
  },
  {
    label: "Last Draft Date",
    path: "achData.lastDraftDate",
    field: "lastDraftDate",
    type: "dateOnly",
    disableAfterApproved: true
  },
  {
    label: "DSCR",
    path: "loanResults.loanResult.[loanId].loanEconomics.dscr",
    field: "dscr",
    type: "readOnly",
    skipRules: true
  },
  {
    label: "FPL - Monthly P&I",
    path: "loanEconomics.fplMonthlyPI",
    field: "fplMonthlyPI",
    type: "currency",
    skipRules: true
  },
  {
    label: "FPL - Monthly Total Payment",
    path: "loanEconomics.fplMonthlyTotalPayment",
    field: "fplMonthlyTotalPayment",
    type: "currency",
    skipRules: true
  },
  {
    label: "Origination Points (%)",
    path: "loanDetailId.originationPointPercentage",
    field: "originationPointPercentage",
    type: "nonEditable",
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Discount Points (%)",
    path: "loanDetailId.discountPointPercentage",
    field: "discountPointPercentage",
    type: "nonEditable",
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Discount Points ($)",
    path: "loanDetailId.discountPointAmount",
    field: "discountPointAmount",
    type: "currency",
    // hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Monthly Qualifying P&I",
    path: "loanResults.loanResult.[loanId].loanEconomics.monthlyQualifyingPI",
    ttfInfoPath:
      "results.assignedTpResult.loanResult.[loanId].loanEconomics.monthlyQualifyingPI",
    field: "monthlyQualifyingPI",
    type: "nonEditable",
    outputDataMadeInput: true,
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Lifetime Floor (%)",
    path: "loanResults.loanResult.[loanId].loanPricing.lifeTimeFloor",
    ttfInfoPath:
      "results.assignedTpResult.loanResult.[loanId].loanPricing.lifeTimeFloor",
    field: "lifeTimeFloor" ,
    type: "percentage",
    skipRules: true,
    isMultiplyBy100: true,
    // hidden: (loanDetails: any, view: string) =>
    //   loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Initial Rate Adjustment Date",
    path: "loanEconomics.initialRateAdjustmentDate",
    field: "initialRateAdjustmentDate" ,
    type: "dateOnly",
    skipRules: true,
    // hidden: (loanDetails: any, view: string) =>
    //   loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Initial Pay Adjustment Date",
    path: "loanEconomics.initialPayAdjustmentDate",
    field: "initialPayAdjustmentDate" ,
    type: "dateOnly",
    skipRules: true,
    // hidden: (loanDetails: any, view: string) =>
    //   loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "ARM Type",
    path: "loanEconomics.armType",
    field: "armType" ,
    values: armTypeOptions,
    type: "dropdown",
    skipRules: true,
    // hidden: (loanDetails: any, view: string) =>
    //   loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "MERS Min #",
    path: "loanInfo.mersMinNumber",
    field: "mersMinNumber",
    type: "text",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanStage  !== "POST"
  },
  {
    label: "Registration Date",
    path: "loanInfo.mersRegistrationDate",
    field: "mersRegistrationDate",
    type: "dateOnly",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanStage  !== "POST"
  },
  {
    label: "Transfer of Beneficial Rights (TOB) Batch ID",
    path: "loanInfo.mersTobBatchId",
    field: "mersTobBatchId",
    type: "text",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanStage !== "POST"
  },
  {
    label: "Transfer Of Servicing Rights (TOS)",
    path: "loanInfo.mersTos",
    field: "mersTos",
    type: "text",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanStage !== "POST"
  },
];

export const BridgeUserFields = [
  {
    label: "Entity Name",
    path: "customer.accountName",
    borrowerAliasKey: "borrowingEntityName",
    field: "accountName",
    rulesKey: "partyType",
    disableAfterApproved: true,
    type: "text",
    partyType: "account"
  },
   {
    label: "Entity Type",
    path: "customer.entityType",
    borrowerAliasKey: "entityType",
    field: "entityType",
    rulesKey: "partyType",
    disableAfterApproved: true,
    type: "dropdown",
    partyType: "account",
    values: bridgeEntityTypeValues
  },
  {
    label: "% of Ownership of Entity",
    path: "ownershipOfEntity",
    guarantorAliasKey: "pOEntity",
    rulesKey: "ownershipOfEntity",
    field: "ownershipOfEntity",
    disableAfterApproved: true,
    type: "percentage"
  },
  {
    label: "First Name",
    field: "firstName",
    path: "customer.firstName",
    borrowerAliasKey: "firstName",
    guarantorAliasKey: "guarantorFirstName",
    type: "text",
    disableAfterApproved: true,
    partyType: "person",
    skipRules: true
  },
  {
    label: "Middle Name",
    field: "middleName",
    path: "customer.middleName",
    borrowerAliasKey: "middleName",
    guarantorAliasKey: "guarantorMiddleName",
    type: "text",
    disableAfterApproved: true,
    partyType: "person",
    skipRules: true
  },
  {
    label: "Last Name",
    field: "lastName",
    path: "customer.lastName",
    borrowerAliasKey: "lastName",
    guarantorAliasKey: "guarantorLastName",
    type: "text",
    disableAfterApproved: true,
    partyType: "person",
    skipRules: true
  },
  {
    label: "Foreign National",
    field: "foreignNationalString",
    path: "customer.foreignNationalString",
    borrowerAliasKey: "foreignNationalString",
    guarantorAliasKey: "foreignNationalString",
    rulesKey: "foreignNationalString",
    disableAfterApproved: true,
    type: "dropdown",
    values: yesNoDropdown,
    partyType: "person",
  },
  {
    label: "Original Credit Score Date",
    field: "originalCreditScoreReportDate",
    path: "originalCreditScoreReportDate",
    borrowerAliasKey: "originalCreditReportDate",
    guarantorAliasKey: "originalCreditReportDate",
    ddIdentifier: "originalCreditScoreReportDate",
    rulesKey: "originalCreditScoreReportDate",
    disableAfterApproved: true,
    type: "date",
    partyType: "person"
  },
  {
    label: "Original Credit Score (Median)",
    field: "originalCreditScoreMedian",
    path: "originalCreditScoreMedian",
    borrowerAliasKey: "originalCreditScoreMedian",
    guarantorAliasKey: "creditScore",
    rulesKey: "originalCreditScoreMedian",
    disableAfterApproved: true,
    type: "creditscore",
    partyType: "person"
  },
  {
    label: "Billing Phone Number",
    field: "contactNumber",
    path: "customer.contactList.0.contactNumber",
    auditPath: "customer.contactList[0].contactNumber",
    borrowerAliasKey: "billingPhoneNumber",
    disableAfterApproved: true,
    skipRules: true,
    type: "phone"
  },
  {
    label: "Email",
    field: "email",
    path: "customer.contactList.0.email",
    auditPath: "customer.contactList[0].email",
    borrowerAliasKey: "borrowerEmail",
    disableAfterApproved: true,
    type: "email",
    skipRules: true
  },
  {
    label: "Experience in the last 3 years",
    field: "experience",
    path: "experience",
    borrowerAliasKey: "borrowerExperience",
    // guarantorAliasKey: "guarantorExperience",
    type: "number",
    // hidden: (data: any, view: string) => {
    //   return data?.loanInfo?.toorakProduct !== "Bridge";
    // }
  },
  {
    label: "Experience in the last 3 to 10 years",
    field: "experienceIn3To10Years",
    path: "experienceIn3To10Years",
    borrowerAliasKey: "experienceIn3To10Years",
    // guarantorAliasKey: "experienceIn3To10Years",
    type: "number",
    // hidden: (data: any, view: string) => {
    //   return data?.loanInfo?.toorakProduct !== "Bridge";
    // }
  },
  {
    label: "Full Billing Address",
    field: "addressLine1",
    path: "customer.addressList.0.addressLine1",
    auditPath: "customer.addressList[0].addressLine1",
    borrowerAliasKey: "billingAddress",
    guarantorAliasKey: "billingAddress",
    skipRules: true,
    disableAfterApproved: true,
    type: "billingaddress"
  },
  {
    label: "EIN",
    path: "customer.eiNumber",
    field: "eiNumber",
    borrowerAliasKey: "eiNumber",
    guarantorAliasKey: "eiNumber",
    type: "ein",
    skipRules: true,
    partyType: "account"
  },
  {
    label: "SSN",
    path: "customer.ssNumber",
    field: "ssNumber",
    borrowerAliasKey: "ssNumber",
    guarantorAliasKey: "ssNumber",
    type: "ssn",
    skipRules: true,
    partyType: "person"
  },
  {
    label: "ID Expiration Date",
    path: "customer.passportExpirationDate",
    field: "passportExpirationDate",
    borrowerAliasKey: "passportExpirationDate",
    guarantorAliasKey: "passportExpirationDate",
    type: "dateOnly",
    disableAfterApproved: true,
    skipRules: true,
    partyType: "person"
  },
  {
    label: "Equifax",
    path: "customer.creditInformation.Equifax.creditValue",
    auditPath: "customer.creditInformation.[creditInfoId].creditValue",
    field: "Equifax",
    borrowerAliasKey: "Equifax",
    guarantorAliasKey: "Equifax",
    type: "creditscore",
    disableAfterApproved: true,
    skipRules: false,
    customLabel: true,
    partyType: "person"
  },
  {
    label: "Experian",
    path: "customer.creditInformation.Experian.creditValue",
    auditPath: "customer.creditInformation.[creditInfoId].creditValue",
    field: "Experian",
    borrowerAliasKey: "Experian",
    guarantorAliasKey: "Experian",
    type: "creditscore",
    disableAfterApproved: true,
    skipRules: false,
    customLabel: true,
    partyType: "person"
  },
  {
    label: "Trans Union",
    path: "customer.creditInformation.TransUnion.creditValue",
    auditPath: "customer.creditInformation.[creditInfoId].creditValue",
    field: "TransUnion",
    borrowerAliasKey: "TransUnion",
    guarantorAliasKey: "TransUnion",
    type: "creditscore",
    disableAfterApproved: true,
    skipRules: false,
    customLabel: true,
    partyType: "person"
  },
  {
    label: "Hard Pull",
    path: "customer.isHardPull",
    field: "isHardPull",
    borrowerAliasKey: "isHardPull",
    guarantorAliasKey: "isHardPull",
    type: "yesnodropdown",
    disableAfterApproved: true,
    values: yesNoDropdown,
    skipRules: false,
    partyType: "person",
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Last Foreclosure Date",
    path: "customer.lastFcDate",
    field: "lastFcDate",
    borrowerAliasKey: "lastFcDate",
    guarantorAliasKey: "lastFcDate",
    type: "dateOnly",
    partyType: "person",
    // hideClearIcon: (data: any) => true
  },
  {
    label: "Last Short Sale Date",
    path: "customer.lastSsDate",
    field: "lastSsDate",
    borrowerAliasKey: "lastSsDate",
    guarantorAliasKey: "lastSsDate",
    type: "dateOnly",
    partyType: "person",
    // hideClearIcon: (data: any) => true
  },
  {
    label: "Last Deeds in Lieu Date",
    path: "customer.lastDilDate",
    field: "lastDilDate",
    borrowerAliasKey: "lastDilDate",
    guarantorAliasKey: "lastDilDate",
    type: "dateOnly",
    partyType: "person",
    // hideClearIcon: (data: any) => true
  },
  {
    label: "Last Bankruptcy Date",
    path: "customer.lastBkDate",
    field: "lastBkDate",
    borrowerAliasKey: "lastBkDate",
    guarantorAliasKey: "lastBkDate",
    type: "dateOnly",
    partyType: "person",
    // hideClearIcon: (data: any) => true
  },
  {
    label: "Last Delinquency Date",
    path: "customer.lastDelinquencyDate",
    field: "lastDelinquencyDate",
    borrowerAliasKey: "lastDelinquencyDate",
    guarantorAliasKey: "lastDelinquencyDate",
    type: "dateOnly",
    partyType: "person",
    // hideClearIcon: (data: any) => true
  },
  {
    label: "Months Since Foreclosure",
    path: "customer.lastFcMonths",
    field: "lastFcMonths",
    borrowerAliasKey: "lastFcMonths",
    guarantorAliasKey: "lastFcMonths",
    type: "nonEditable",
    partyType: "person",
    formulaVariables: [
      {
        key: "Last Foreclosure Date",
        fieldPath: "customer.lastFcDate"
      },
      {
        key: "Origination Date",
        fieldPath: "loanInfo.originationDate"
      },
    ],
    formulaText: `= Last Foreclosure Date - Origination Date`
  },
  {
    label: "Months Since Short Sale",
    path: "customer.lastSsMonths",
    field: "lastSsMonths",
    borrowerAliasKey: "lastSsMonths",
    guarantorAliasKey: "lastSsMonths",
    type: "nonEditable",
    partyType: "person"
  },
  {
    label: "Months Since Deeds in Lieu",
    path: "customer.lastDilMonths",
    field: "lastDilMonths",
    borrowerAliasKey: "lastDilMonths",
    guarantorAliasKey: "lastDilMonths",
    type: "nonEditable",
    partyType: "person"
  },
  {
    label: "Month Since Bankruptcy",
    path: "customer.lastBkMonths",
    field: "lastBkMonths",
    borrowerAliasKey: "lastBkMonths",
    guarantorAliasKey: "lastBkMonths",
    type: "nonEditable",
    partyType: "person",
    formulaVariables: [
      {
        key: "Last Bankruptcy Date",
        fieldPath: "customer.lastBkDate"
      },
      {
        key: "Origination Date",
        fieldPath: "loanInfo.originationDate"
      },
    ],
    formulaText: `= Last Bankruptcy Date - Origination Date`
  },
  {
    label: "Months Since Delinquency",
    path: "customer.lastDelinquencyMonths",
    field: "lastDelinquencyMonths",
    borrowerAliasKey: "lastDelinquencyMonths",
    guarantorAliasKey: "lastDelinquencyMonths",
    type: "nonEditable",
    partyType: "person"
  },
  {
    label: "Borrower GUC Experience",
    field: "borrowerGUCExperience",
    path: "borrowerGUCExperience",
    borrowerAliasKey: "borrowerGUCExperience",
    // guarantorAliasKey: "borrowerGUCExperience",
    type: "number",
    // hidden: (data: any, view: string) => {
    //   return data?.loanInfo?.toorakProduct !== "Ground-Up";
    // }
  },
  {
    label: "Fix/Flip Experience",
    field: "heavyRehabExperience",
    path: "heavyRehabExperience",
    borrowerAliasKey: "heavyRehabExperience",
    // guarantorAliasKey: "heavyRehabExperience",
    type: "number",
    // hidden: (data: any, view: string) => {
    //   return data?.loanInfo?.toorakProduct !== "Ground-Up";
    // }
  },
   {
    label: "Primary Borrower",
    field: "isPrimary",
    path: "isPrimary",
    borrowerAliasKey: "isPrimary",
    type: "yesnodropdown",
    disableAfterApproved: true,
    values: yesNoDropdown,
    partyType: "person",
  },
];

export const DSCRUserFields = [
  {
    label: "Entity Name",
    path: "customer.accountName",
    borrowerAliasKey: "borrowingEntityName",
    field: "accountName",
    rulesKey: "partyType",
    disableAfterApproved: true,
    type: "text",
    partyType: "account"
  },
  {
    label: "Entity Type",
    path: "customer.entityType",
    borrowerAliasKey: "entityType",
    field: "entityType",
    rulesKey: "partyType",
    disableAfterApproved: true,
    type: "dropdown",
    partyType: "account",
    values: entityTypeValues
  },
  {
    label: "% of Ownership of Entity",
    path: "ownershipOfEntity",
    guarantorAliasKey: "pOEntity",
    rulesKey: "ownershipOfEntity",
    field: "ownershipOfEntity",
    disableAfterApproved: true,
    type: "percentage"
  },
  {
    label: "First Name",
    field: "firstName",
    path: "customer.firstName",
    borrowerAliasKey: "firstName",
    guarantorAliasKey: "guarantorFirstName",
    type: "text",
    disableAfterApproved: true,
    partyType: "person",
    skipRules: true
  },
  {
    label: "Last Name",
    field: "lastName",
    path: "customer.lastName",
    borrowerAliasKey: "lastName",
    guarantorAliasKey: "guarantorLastName",
    type: "text",
    disableAfterApproved: true,
    partyType: "person",
    skipRules: true
  },
  {
    label: "Foreign National",
    field: "foreignNationalString",
    path: "customer.foreignNationalString",
    borrowerAliasKey: "foreignNationalString",
    guarantorAliasKey: "foreignNationalString",
    rulesKey: "foreignNationalString",
    disableAfterApproved: true,
    type: "dropdown",
    values: foreignNationalOptions
  },
  {
    label: "Original Credit Score Date",
    field: "originalCreditScoreReportDate",
    path: "originalCreditScoreReportDate",
    borrowerAliasKey: "originalCreditReportDate",
    guarantorAliasKey: "originalCreditReportDate",
    ddIdentifier: "originalCreditScoreReportDate",
    rulesKey: "originalCreditScoreReportDate",
    disableAfterApproved: true,
    type: "date",
    partyType: "person"
  },
  {
    label: "Original Credit Score (Median)",
    field: "originalCreditScoreMedian",
    path: "originalCreditScoreMedian",
    borrowerAliasKey: "originalCreditScoreMedian",
    guarantorAliasKey: "creditScore",
    rulesKey: "originalCreditScoreMedian",
    disableAfterApproved: true,
    type: "creditscore",
    partyType: "person"
  },
  {
    label: "Billing Phone Number",
    field: "contactNumber",
    path: "customer.contactList.0.contactNumber",
    auditPath: "customer.contactList[0].contactNumber",
    borrowerAliasKey: "billingPhoneNumber",
    disableAfterApproved: true,
    type: "phone",
    skipRules: true
  },
  {
    label: "Email",
    field: "email",
    path: "customer.contactList.0.email",
    auditPath: "customer.contactList[0].email",
    borrowerAliasKey: "borrowerEmail",
    disableAfterApproved: true,
    type: "email",
    skipRules: true
  },
  // {
  //   label: "Experience",
  //   field: "experience",
  //   path: "experience",
  //   borrowerAliasKey: "borrowerExperience",
  //   rulesKey: "borrowerExperience",
  //   type: "number"
  // },
  {
    label: "Full Billing Address",
    field: "addressLine1",
    path: "customer.addressList.0.addressLine1",
    auditPath: "customer.addressList[0].addressLine1",
    borrowerAliasKey: "billingAddress",
    skipRules: true,
    disableAfterApproved: true,
    type: "billingaddress"
  },
  {
    label: "EIN",
    path: "customer.eiNumber",
    field: "eiNumber",
    borrowerAliasKey: "eiNumber",
    guarantorAliasKey: "eiNumber",
    type: "ein",
    skipRules: true,
    partyType: "account"
  },
  {
    label: "SSN",
    path: "customer.ssNumber",
    field: "ssNumber",
    borrowerAliasKey: "ssNumber",
    guarantorAliasKey: "ssNumber",
    type: "ssn",
    skipRules: true,
    partyType: "person"
  },
  {
    label: "ID Expiration Date",
    path: "customer.passportExpirationDate",
    field: "passportExpirationDate",
    borrowerAliasKey: "passportExpirationDate",
    guarantorAliasKey: "passportExpirationDate",
    type: "dateOnly",
    disableAfterApproved: true,
    skipRules: true,
    partyType: "person"
  },
  {
    label: "Equifax",
    path: "customer.creditInformation.Equifax.creditValue",
    auditPath: "customer.creditInformation.[creditInfoId].creditValue",
    field: "Equifax",
    borrowerAliasKey: "Equifax",
    guarantorAliasKey: "Equifax",
    type: "creditscore",
    disableAfterApproved: true,
    skipRules: false,
    customLabel: true,
    partyType: "person"
  },
  {
    label: "Experian",
    path: "customer.creditInformation.Experian.creditValue",
    auditPath: "customer.creditInformation.[creditInfoId].creditValue",
    field: "Experian",
    borrowerAliasKey: "Experian",
    guarantorAliasKey: "Experian",
    type: "creditscore",
    disableAfterApproved: true,
    skipRules: false,
    customLabel: true,
    partyType: "person"
  },
  {
    label: "Trans Union",
    path: "customer.creditInformation.TransUnion.creditValue",
    auditPath: "customer.creditInformation.[creditInfoId].creditValue",
    field: "TransUnion",
    borrowerAliasKey: "TransUnion",
    guarantorAliasKey: "TransUnion",
    type: "creditscore",
    disableAfterApproved: true,
    skipRules: false,
    customLabel: true,
    partyType: "person"
  },
  {
    label: "Hard Pull",
    path: "customer.isHardPull",
    field: "isHardPull",
    borrowerAliasKey: "isHardPull",
    guarantorAliasKey: "isHardPull",
    type: "yesnodropdown",
    disableAfterApproved: true,
    values: yesNoDropdown,
    skipRules: false,
    partyType: "person",
    hidden: (loanDetails: any, view: string) => view === "reconcile"
  },
  {
    label: "Last Foreclosure Date",
    path: "customer.lastFcDate",
    field: "lastFcDate",
    borrowerAliasKey: "lastFcDate",
    guarantorAliasKey: "lastFcDate",
    type: "dateOnly",
    partyType: "person",
    // hideClearIcon: (data: any) => true
  },
  {
    label: "Last Short Sale Date",
    path: "customer.lastSsDate",
    field: "lastSsDate",
    borrowerAliasKey: "lastSsDate",
    guarantorAliasKey: "lastSsDate",
    type: "dateOnly",
    partyType: "person",
    // hideClearIcon: (data: any) => true
  },
  {
    label: "Last Deeds in Lieu Date",
    path: "customer.lastDilDate",
    field: "lastDilDate",
    borrowerAliasKey: "lastDilDate",
    guarantorAliasKey: "lastDilDate",
    type: "dateOnly",
    partyType: "person",
    // hideClearIcon: (data: any) => true
  },
  {
    label: "Last Bankruptcy Date",
    path: "customer.lastBkDate",
    field: "lastBkDate",
    borrowerAliasKey: "lastBkDate",
    guarantorAliasKey: "lastBkDate",
    type: "dateOnly",
    partyType: "person",
    // hideClearIcon: (data: any) => true
  },
  {
    label: "Last Delinquency Date",
    path: "customer.lastDelinquencyDate",
    field: "lastDelinquencyDate",
    borrowerAliasKey: "lastDelinquencyDate",
    guarantorAliasKey: "lastDelinquencyDate",
    type: "dateOnly",
    partyType: "person",
    // hideClearIcon: (data: any) => true
  },
  {
    label: "Months Since Foreclosure",
    path: "customer.lastFcMonths",
    field: "lastFcMonths",
    borrowerAliasKey: "lastFcMonths",
    guarantorAliasKey: "lastFcMonths",
    type: "nonEditable",
    partyType: "person"
  },
  {
    label: "Months Since Short Sale",
    path: "customer.lastSsMonths",
    field: "lastSsMonths",
    borrowerAliasKey: "lastSsMonths",
    guarantorAliasKey: "lastSsMonths",
    type: "nonEditable",
    partyType: "person"
  },
  {
    label: "Months Since Deeds in Lieu",
    path: "customer.lastDilMonths",
    field: "lastDilMonths",
    borrowerAliasKey: "lastDilMonths",
    guarantorAliasKey: "lastDilMonths",
    type: "nonEditable",
    partyType: "person"
  },
  {
    label: "Month Since Bankruptcy",
    path: "customer.lastBkMonths",
    field: "lastBkMonths",
    borrowerAliasKey: "lastBkMonths",
    guarantorAliasKey: "lastBkMonths",
    type: "nonEditable",
    partyType: "person"
  },
  {
    label: "Months Since Delinquency",
    path: "customer.lastDelinquencyMonths",
    field: "lastDelinquencyMonths",
    borrowerAliasKey: "lastDelinquencyMonths",
    guarantorAliasKey: "lastDelinquencyMonths",
    type: "nonEditable",
    partyType: "person"
  }
];

export const BridgePropertyFields = [
  {
    label: "Property Type",
    path: "propertyinfo.propertyType",
    field: "propertyType",
    type: "dropdown",
    disableAfterApproved: true,
    values: propertyTypeDropDown.map((val) =>
      val === "SFR" ? "Single Family Detached" : val
    )
  },
  {
    label: "Appraisal Reported NOI/NCF ($)",
    path: "propertyEconomics.appraisalReportedNoiNcf",
    field: "appraisalReportedNoiNcf",
    aliasKey: "appraisalReported",
    rulesKey: "appraisalReportedNoiNcf",
    type: "currency"
  },
  // {
  //   label: "% Occupied (%)",
  //   path: "propertyinfo.occupiedPercentage",
  //   field: "occupiedPercentage",
  //   aliasKey: "percentageOccupied",
  //   rulesKey: "percentOccupied",
  //   type: "percentage"
  // },
  {
    label: "Change Of Use Case",
    path: "propertyinfo.changeInUseCase",
    field: "changeInUseCase",
    type: "dropdown",
    values: yOrNDropDown
  },
  {
    label: "Expansion (>20%/+750 sq.ft)",
    path: "propertyinfo.expansion",
    field: "expansion",
    type: "dropdown",
    values: yOrNDropDown
  },
  {
    label: "Gross Potential Rent ($)",
    path: "propertyEconomics.grossPotentialRent",
    field: "grossPotentialRent",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Insurance ($)",
    path: "propertyEconomics.insurance",
    field: "insurance",
    type: "currency",
    disableAfterApproved: true
  },
  // {
  //   label: "Rental Cashflow Ratio",
  //   path: "propertyEconomics.rentalCashflowRatio",
  //   field: "rentalCashflowRatio",
  //   type: "rentalCashflowRatio",
  //   skipRules: true
  // },
  {
    label: "Property Acquisition Date",
    path: "propertyinfo.propertyAcquisitionDate",
    field: "propertyAcquisitionDate",
    aliasKey: "propertyAcquisitionDate",
    rulesKey: "propertyAcquisitionDate",
    type: "dateOnly",
    disableAfterApproved: true
  },
  {
    label: "Third Party Valuation Date",
    path: "propertyinfo.propertyValuationDate",
    field: "propertyValuationDate",
    aliasKey: "originalPropertyValuationDate",
    type: "dateOnly",
    disableAfterApproved: true
  },
  {
    label: "Purchase Price ($)",
    path: "propertyEconomics.purchasePrice",
    field: "purchasePrice",
    aliasKey: "purchasePrice",
    rulesKey: "purchasePrice",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Pre-Rehab Square Footage",
    path: "propertyinfo.preRehabSquareFootage",
    field: "preRehabSquareFootage",
    aliasKey: "preRehabSquareFootage",
    rulesKey: "preRehabSquareFootage",
    type: "Number",
    disableAfterApproved: true
  },
  {
    label: "Post-Rehab Square Footage",
    path: "propertyinfo.postRehabSquareFootage",
    field: "postRehabSquareFootage",
    aliasKey: "postRehabSquareFootage",
    rulesKey: "postRehabSquareFootage",
    type: "Number",
    disableAfterApproved: true
  },
  {
    label: "Address Line 1",
    path: "propertyLocation.addressLine1",
    field: "addressLine1",
    aliasKey: "street_line",
    type: "autoProperty",
    disableAfterApproved: true
  },
  {
    label: "City",
    path: "propertyLocation.city",
    field: "city",
    type: "text",
    disableAfterApproved: true
  },
  {
    label: "State",
    path: "propertyLocation.state",
    field: "state",
    type: "dropdown",
    disableAfterApproved: true,
    values: USStates
  },
  {
    label: "Postal Code",
    path: "propertyLocation.postalCode",
    field: "postalCode",
    aliasKey: "zipCode",
    rulesKey: "postalCode",
    type: "postalcode",
    disableAfterApproved: true
  },
  {
    label: "Appraiser Name",
    path: "propertyinfo.appraisalVendor",
    field: "appraisalVendor",
    type: "text",
    skipRules: true
  },
  {
    label: "Appraisal Certification / License",
    path: "propertyinfo.appraisalCertificationOrLicense",
    field: "appraisalCertificationOrLicense",
    type: "text",
    skipRules: true
  },
  {
    label: "Appraisal Company Name",
    path: "propertyinfo.appraisalCompanyName",
    field: "appraisalCompanyName",
    type: "text",
    skipRules: true
  },
  {
    label: "AMC Company Name",
    path: "propertyinfo.amcCompanyName",
    field: "amcCompanyName",
    type: "text",
    skipRules: true
  },
  {
    label: "Appraisal Certification / License Expiration Date",
    path: "propertyinfo.appraisalExpirationDate",
    field: "appraisalExpirationDate",
    type: "dateOnly",
    skipRules: true
  },
  {
    label: "Appraisal State",
    path: "propertyinfo.appraisalState",
    field: "appraisalState",
    type: "dropdown",
    values: USStates,
    skipRules: true
  },
  {
    label: "Pre-Rehab Units",
    path: "propertyinfo.preRehabUnits",
    field: "preRehabUnits",
    type: "number",
    disableAfterApproved: true
  },
  {
    label: "Post-Rehab Units",
    path: "propertyinfo.postRehabUnits",
    field: "postRehabUnits",
    type: "number",
    disableAfterApproved: true
  },
  {
    label: "Annual Property Taxes ($)",
    path: "propertyEconomics.annualPropertyTaxes",
    field: "annualPropertyTaxes",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "FPL - Monthly Property Tax",
    path: "propertyEconomics.fplMonthlyPropertyTax",
    field: "fplMonthlyPropertyTax",
    type: "currency",
    skipRules: true
  },
  {
    label: "FPL - Monthly Insurance",
    path: "propertyEconomics.fplMonthlyInsurance",
    field: "fplMonthlyInsurance",
    type: "currency",
    skipRules: true
  },
  {
    label: "ADU",
    path: "propertyinfo.additionalDwellingUnit",
    field: "additionalDwellingUnit",
    type: "dropdown",
    values: yesNoDropdown,
    skipRules: true
  },
  {
    label: "Cost Basis ($)",
    path: "propertyEconomics.costBasis",
    field: "costBasis",
    aliasKey: "costBasis",
    rulesKey: "costBasisAfterCostIncurred",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: [
      "Valuation Source",
      "Valuation Value",
      "Valuation Date",
      "AS Repaired Value ARV "
    ],
    path: "valuations",
    key: [
      "appraisalType",
      "appraisalAsIsValue",
      "appraisalDate",
      "appraisalArvValue"
    ],
    field: [
      "appraisalType",
      "appraisalAsIsValue",
      "appraisalDate",
      "appraisalArvValue"
    ],
    aliasKey: [
      "appraisalType",
      "appraisalAsIsValue",
      "appraisalDate",
      "appraisalArvValue"
    ],
    rulesKey: [
      "appraisalType",
      "appraisalAsIsValue",
      "appraisalDate",
      "appraisalArvValue"
    ],
    type: ["dropdown", "currency", "dateOnly", "currency"],
    disableAfterApproved: [true, true, true, true],
    values: [valuationSourceList, undefined, undefined, undefined],
    skipRules: [false, false, false, false],
    auditPath: [
      "valuations[valuationId].appraisalType",
      "valuations[valuationId].appraisalAsIsValue",
      "valuations[valuationId].appraisalDate",
      "valuations[valuationId].appraisalArvValue"
    ]
  },
  {
    label: "Property Purchased with Debt",
    path: "propertyinfo.isPurchasedWithDebt",
    field: "isPurchasedWithDebt",
    type: "dropdown",
    values: yesNoDropdown
    // hidden: (data: any, view: string) => {
    //   return view === "reconcile";
    // }
  },
  {
    label: "Number of Units",
    path: "propertyinfo.propertyUnits",
    field: "propertyUnits",
    type: "number",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false,
    aliasKey: "numberOfUnits"
  },
  {
    label: "Monthly Property Taxes ($)",
    path: "propertyEconomics.annualPropertyTaxes",
    field: "monthlyPropertyTaxes",
    type: "currency",
    disableAfterApproved: true,
    isReadOnlyField: true
  },
  {
    label: "Monthly Insurance ($)",
    path: "propertyEconomics.insurance",
    field: "monthlyInsurance",
    type: "currency",
    disableAfterApproved: true,
    isReadOnlyField: true
  }
];

export const DSCRPropertyFields = [
  {
    label: "Property Type",
    path: "propertyinfo.propertyType",
    field: "propertyType",
    type: "dropdown",
    disableAfterApproved: true,
    values: [ ...thirtyYearPropertyTypeDropDown, ...multiFamMixedUsePropertyTypeDropDown].map((val) =>
      val === "SFR" ? "Single Family Detached" : val
    )
  },
  // {
  //   label: "% Occupied (%)",
  //   path: "propertyinfo.occupiedPercentage",
  //   field: "occupiedPercentage",
  //   aliasKey: "percentageOccupied",
  //   rulesKey: "percentOccupied",
  //   type: "percentage"
  // },
  {
    label: "Property Acquisition Date",
    path: "propertyinfo.propertyAcquisitionDate",
    field: "propertyAcquisitionDate",
    aliasKey: "propertyAcquisitionDate",
    rulesKey: "propertyAcquisitionDate",
    type: "dateOnly",
    disableAfterApproved: true
  },
  {
    label: `Original "As Is" Appraisal Value ($)`,
    path: "propertyEconomics.originalAsIsAppraisalValue",
    field: "originalAsIsAppraisalValue",
    aliasKey: "originalAppraisalValue",
    rulesKey: "originalAsIsAppraisalValue",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Third Party Valuation ($)",
    path: "propertyEconomics.thirdPartyValuation",
    field: "thirdPartyValuation",
    aliasKey: "thirdPartyValuation",
    rulesKey: "thirdPartyValuation",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Most Recent Property Valuation Date",
    path: "propertyinfo.recentPropertyValuationDate",
    field: "recentPropertyValuationDate",
    aliasKey: "propertyValuationDate",
    rulesKey: "mostRecentPropertyValuationDate",
    type: "dateOnly",
    disableAfterApproved: true
  },
  {
    label: "Purchase Price ($)",
    path: "propertyEconomics.purchasePrice",
    field: "purchasePrice",
    aliasKey: "purchasePrice",
    rulesKey: "purchasePrice",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Cost Basis ($)",
    path: "propertiesResults.loanEconomics.costBasisCalculated",
    field: "costBasisCalculated",
    aliasKey: "costBasisCalculated",
    rulesKey: "costBasisCalculated",
    type: "currency",
    disableAfterApproved: true,
    isReadOnlyField: true
  },
  {
    label: [
      "Rental Characterisation",
      "Current Lease Term",
      "Market Rent Monthly",
      "In Place Lease Rent Monthly",
      "Most Recent Lease Rent Monthly",
      "Third-party Rent Estimate",
      "ADU"
    ],
    path: "propertyUnit",
    key: [
      "leaseStatus",
      "currentLeaseTermMonthly",
      "marketRentMonthly",
      "inPlaceLeaseRentMonthly",
      "mostRecentLeaseRentMonthly",
      "thirdPartyRentRangeAmount",
      "additionalDwellingUnit"
    ],
    field: [
      "leaseStatus",
      "currentLeaseTermMonthly",
      "marketRentMonthly",
      "inPlaceLeaseRentMonthly",
      "mostRecentLeaseRentMonthly",
      "thirdPartyRentRangeAmount",
      "additionalDwellingUnit"
    ],
    aliasKey: [
      "leaseStatus",
      "currentLeaseTerm",
      "marketRentMonthly",
      "inPlaceLeaseRent",
      "recentLeaseRent",
      "thirdPartyRentRangeAmount",
      "additionalDwellingUnit"
    ],
    rulesKey: [
      "leaseStatus",
      "currentLeaseTermMonths",
      "marketRentMonthly",
      "inPlaceLeaseRentMonthly",
      "mostRecentLeaseRentMonthly",
      "thirdPartyRentRangeAmount",
      "additionalDwellingUnit"
    ],
    type: [
      "dropdown",
      "Number",
      "currency",
      "currency",
      "currency",
      "currency",
      "dropdown"
    ],
    disableAfterApproved: [true, true, true, true, true, true, true],
    values: [
      "leaseStatusDropDown",
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      yesNoDropdown
    ],
    skipRules: [false, false, false, false, false, false, false]
  },
  {
    label: "Annual Property Taxes ($)",
    path: "propertyEconomics.annualPropertyTaxes",
    field: "annualPropertyTaxes",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Annual Hazard Insurance ($)",
    path: "propertyEconomics.annualHazardInsurance",
    field: "annualHazardInsurance",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Annual Flood Insurance ($)",
    path: "propertyEconomics.annualFloodInsurance",
    field: "annualFloodInsurance",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Annual HOA Fee ($)",
    path: "propertyEconomics.annualHoaFee",
    field: "annualHoaFee",
    aliasKey: "annualHoaFee",
    rulesKey: "annualHOAFee",
    type: "currency",
    disableAfterApproved: true
  },
  {
    label: "Address Line 1",
    path: "propertyLocation.addressLine1",
    field: "addressLine1",
    aliasKey: "street_line",
    type: "autoProperty",
    disableAfterApproved: true
  },
  {
    label: "City",
    path: "propertyLocation.city",
    field: "city",
    type: "text",
    disableAfterApproved: true
  },
  {
    label: "State",
    path: "propertyLocation.state",
    field: "state",
    type: "dropdown",
    disableAfterApproved: true,
    values: USStates
  },
  {
    label: "Postal Code",
    path: "propertyLocation.postalCode",
    field: "postalCode",
    aliasKey: "zipCode",
    rulesKey: "postalCode",
    type: "postalcode",
    disableAfterApproved: true
  },
  {
    label: "Escrow Taxes at Closing ($)",
    path: "propertySummary.escrowTaxes",
    field: "escrowTaxes",
    type: "readOnly"
  },
  {
    label: "Escrow Insurance at Closing ($)",
    path: "propertySummary.escrowInsurance",
    field: "escrowInsurance",
    type: "readOnly"
  },
  {
    label: "Collateral ID",
    path: "propertyinfo.collateralId",
    field: "collateralId",
    type: "alphanumeric",
    disableAfterApproved: true
  },
  {
    label: "Appraisal Type",
    path: "propertyinfo.appraisalType",
    field: "appraisalType",
    type: "text"
  },
  {
    label: "Appraiser Name",
    path: "propertyinfo.appraisalVendor",
    field: "appraisalVendor",
    type: "text",
    skipRules: true
  },
  {
    label: "Appraisal Certification / License",
    path: "propertyinfo.appraisalCertificationOrLicense",
    field: "appraisalCertificationOrLicense",
    type: "text",
    skipRules: true
  },
  {
    label: "Appraisal Company Name",
    path: "propertyinfo.appraisalCompanyName",
    field: "appraisalCompanyName",
    type: "text",
    skipRules: true
  },
  {
    label: "AMC Company Name",
    path: "propertyinfo.amcCompanyName",
    field: "amcCompanyName",
    type: "text",
    skipRules: true
  },
  {
    label: "Appraisal Certification / License Expiration Date",
    path: "propertyinfo.appraisalExpirationDate",
    field: "appraisalExpirationDate",
    type: "dateOnly",
    skipRules: true
  },
  {
    label: "Appraisal State",
    path: "propertyinfo.appraisalState",
    field: "appraisalState",
    type: "dropdown",
    values: USStates,
    skipRules: true
  },
  {
    label: "Original Property Valuation Type",
    path: "propertyinfo.propertyValuationType",
    field: "propertyValuationType",
    type: "dropdown",
    disableAfterApproved: true,
    values: ["As-Is", "ARV", "Subject To"]
  },
  {
    label: "Third Party Valuation Date",
    path: "propertyinfo.propertyValuationDate",
    field: "propertyValuationDate",
    aliasKey: "originalPropertyValuationDate",
    type: "dateOnly",
    disableAfterApproved: true
  },

  {
    label: "FPL - Monthly Property Tax",
    path: "propertyEconomics.fplMonthlyPropertyTax",
    field: "fplMonthlyPropertyTax",
    type: "currency",
    skipRules: true
  },
  {
    label: "FPL - Monthly Insurance",
    path: "propertyEconomics.fplMonthlyInsurance",
    field: "fplMonthlyInsurance",
    type: "currency",
    skipRules: true
  },
  {
    label: "Monthly Property Taxes ($)",
    path: "propertyEconomics.annualPropertyTaxes",
    field: "monthlyPropertyTaxes",
    type: "currency",
    disableAfterApproved: true,
    isReadOnlyField: true
  },
  {
    label: "Monthly Hazard Insurance ($)",
    path: "propertyEconomics.annualHazardInsurance",
    field: "monthlyHazardInsurance",
    type: "currency",
    disableAfterApproved: true,
    isReadOnlyField: true
  },
  {
    label: "Monthly Flood Insurance ($)",
    path: "propertyEconomics.annualFloodInsurance",
    field: "monthlyFloodInsurance",
    type: "currency",
    disableAfterApproved: true,
    isReadOnlyField: true
  },
  {
    label: "Verified Costs ($)",
    path: "propertyEconomics.verifiedCostsAndImprovements",
    field: "verifiedCostsAndImprovements",
    aliasKey: "verifiedCostsAndImprovements",
    rulesKey: "verifiedCostsAndImprovements",
    type: "currency",
    disableAfterApproved: true
  },
];

export const BridgeCalculatedFields = [
  {
    label: "Interest Payment on Day1 ($)",
    path: "loanResult.loanEconomics.initialInterestPayment",
    field: "initialInterestPayment",
    type: "currency",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Interest Rate",
        formatter: (text: string) => sanitizePercentage(text, true),
        fieldPath: "loanEconomics.interestRateAsOfCutOffDate"
      },
      {
        key: "Initial Loan Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.originalLoanAmount"
      }
    ],
    formulaText: `=(Interest Rate * Initial Loan Amount) / 12`
  },
  {
    label: "OOP Budget",
    path: "loanResult.loanFeatures.outOfPocketBudget",
    field: "outOfPocketBudget",
    type: "currency",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Total Budget Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.totalBudgetAmount"
      },
      {
        key: "Financed Budget Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanResult.loanEconomics.financedBudgetAmountCalculated"
      }
    ],
    formulaText: `=Total Budget Amount - Financed Budget Amount`
  },
  {
    label: "Stabilized Flag",
    path: "loanResult.loanCharacterisations.stabilizedFlag",
    field: "stabilizedFlag",
    type: "boolean",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Loan Purpose",
        fieldPath: "loanInfo.loanPurpose"
      },
      {
        key: "Total Budget Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.totalBudgetAmount"
      },
      {
        key: `Original "As Is" Appraisal Value`,
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanResult.loanEconomics.originalAsIsAppraisalValue"
      },
      {
        key: "Purchase Price",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanResult.toorakInterests.purchasePrice"
      }
    ],
    formulaText: `
      =IF(
        AND(
          Loan Purpose = "Purchase",
          Total Budget Amount <= 5% *
          MIN(
            Original "As Is" Appraisal Value,
            Purchase Price ( Only for Purchase Purpose )
          )
        ),
        "Stabilized",
        IF(
          AND(
            Loan Purpose <> "Purchase",
            Total Budget Amount <= 5% * Original "As Is" Appraisal Value
          ),
          "Stabilized",
          "Not Stabilized"
        )
     )
    `
  },
  {
    label: "Loan Structure",
    path: "loanResult.loanCharacterisations.loanStructureType",
    field: "loanStructureType",
    type: "text",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Loan Structure",
        fieldPath: "loanInfo.loanStructure"
      }
    ],
    formulaText: `
      =IF(
        Loan Structure = "Single Funding (With Rehab Escrow)",
        "Dutch",
        "Non-Dutch"
      )
    `
  },
  {
    label: "Financed Budget ($)",
    path: "loanResult.loanEconomics.financedBudgetAmountCalculated",
    field: "financedBudgetAmountCalculated",
    type: "currency",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Original Max Loan Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.cutOffDateMaximumLoanAmount"
      },
      {
        key: "Initial Loan Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.originalLoanAmount"
      }
    ],
    formulaText: `=Original Max Loan Amount - Initial Loan Amount`
  },
  {
    label: "Cross Collateralized (Yes/No)",
    path: "loanResult.loanFeatures.crossCollaterlization",
    field: "crossCollaterlization",
    aliasKey: "selectedCross",
    rulesKey: "crossCollaterlization",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Number of Properties",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: ""
      }
    ],
    formulaText: `
      =IF(
        Number of Properties > 1,
        "Yes",
        "No"
      )
    `
  },
  {
    label: "Budget Test",
    path: "loanResult.guideLineLimit.budgetAmountTest",
    field: "budgetAmountTest",
    aliasKey: "budgetAmountTest",
    rulesKey: "budgetAmountTest",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Total Budget Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.totalBudgetAmount"
      },
      {
        key: "Financed Budget Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanResult.loanEconomics.financedBudgetAmountCalculated"
      }
    ],
    formulaText: `
      =IF(
        Total Budget Amount > Financed Budget Amount,
        "PASS",
        "FAIL"
      )
    `
  },
  {
    label: "Max Leverage Test",
    path: "loanResult.guideLineLimit.leverageTest",
    field: "leverageTest",
    aliasKey: "leverageTest",
    rulesKey: "leverageTest",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: `Max LTV ("As Is")`,
        fieldPath: "loanResult.maxLeverageTest.maxLTVAsIs"
      },
      {
        key: `Max ARV`,
        fieldPath: "loanResult.maxLeverageTest.maxLTVARV"
      },
      {
        key: `Max LTC`,
        fieldPath: "loanResult.maxLeverageTest.maxLttc"
      },
      {
        key: `Financed "As Is" LTV`,
        fieldPath: "loanResult.loanFeatures.financedAsIsLtv"
      },
      {
        key: `Financed "As Repaired" LTV`,
        fieldPath: "loanResult.loanFeatures.financedAsRepairedLtv"
      },
      {
        key: `Financed LTC`,
        fieldPath: "loanResult.loanFeatures.financedLtc"
      }
    ],
    formulaText: `=IF(
        OR(
            OR(
                After Adjustment: Max LTV ("As Is") = "Not Permitted",
                After Adjustment: Max LTV ("As Is") - Financed "As Is" LTV < 0
            ),
            OR(
                After Adjustment: Max ARV = "Not Permitted",
                After Adjustment: Max ARV - Financed "As Repaired" LTV < 0
            ),
            OR(
                After Adjustment: Max LTC = "Not Permitted",
                After Adjustment: Max LTC - Financed LTC < 0
            )
        ),
        FAIL,
        PASS
    )`
  }
];
export const DSCRCalculatedFields = [
  {
    label: "Calculated ACH Start Date",
    path: "loanResult.loanEconomics.desiredStartDateCalculated",
    field: "desiredStartDateCalculated",
    type: "dateOnly",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Financed Interest Reserve",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.financedInterestReserve"
      },
      {
        key: "PITI",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: 
          "loanResults.loanResult.[loanId].loanEconomics.piti"
      },
      {
        key: "First Payment Date",
        formatter: MMMDDYYYY,
        fieldPath: "loanInfo.firstPaymentDateOfLoan"
      }
    ],
    formulaText: `
      =EDATE(
        "First Payment Date",
        IF(
          MOD("Financed Interest Reserve" / "PITI", 1) >= 0.98,
          ROUNDUP("Financed Interest Reserve" / "PITI", 0),
          ROUNDDOWN("Financed Interest Reserve" / "PITI", 0)
        )
      )
    `
  },
  {
    label: "PITI",
    path: "loanResult.loanEconomics.piti",
    field: "piti",
    type: "currency",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Monthly Qualifying P&I",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.interestRateAsOfCutOffDate"
      },
      {
        key: "Annual Property Taxes",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.originalLoanAmount"
      },
      {
        key: "Annual Hazard Insurance",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.interestRateAsOfCutOffDate"
      },
      {
        key: "Annual Flood Insurance",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.originalLoanAmount"
      }
    ],
    formulaText: `
      =Monthly Qualifying P&I +
      SUM(
        Annual Property Taxes + Annual Hazard Insurance + Annual Flood Insurance
      ) / 12
    `
  },
  {
    label: "Max Leverage Test",
    path: "loanResult.logicTests.leverageTest",
    field: "leverageTest",
    aliasKey: "leverageTest",
    rulesKey: "leverageTest",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: `Max LTV ("As Is")`,
        fieldPath: "loanResult.maxLeverageTest.maxLTVAsIs"
      },
      {
        key: `Original "As Is" LTV`,
        fieldPath: "loanResult.maxLeverageTest.originalAsIsLtv"
      },
      {
        key: `Original LTPP`,
        fieldPath: "loanResult.maxLeverageTest.originalLtpp"
      },
      {
        key: `LTC`,
        fieldPath: "loanResult.loanFeatures.originalLtc"
      }
    ],
    formulaText: `=IF(
        OR(
                    OR(
                  After Adjustment: Max LTV ( "As Is" ) = "Not Permitted",
                  After Adjustment: Max LTV ( "As Is" ) - Original "As Is" LTV < 0
            ),
                    AND(
                  Original LTPP / LTC ! = null,
                  After Adjustment: Max LTV ( "As Is" ) - Original LTPP / LTC < 0
            ) 
        ),
          "FAIL",
          "PASS" 
    )`
  }
];

export const BridgeDataReconCalculatedFields = [
  {
    label: "Interest Payment on Day1 ($)",
    path: "loanResults.loanResult.[loanId].loanEconomics.initialInterestPayment",
    field: "initialInterestPayment",
    type: "currency",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Loan Structure",
        fieldPath:
          "loanResults.loanResult.[loanId].loanCharacterisations.loanStructureType"
      },
      {
        key: "Interest Rate",
        formatter: (text: string) => sanitizePercentage(text, true),
        fieldPath: "loanEconomics.interestRateAsOfCutOffDate"
      },
      {
        key: "Initial Loan Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.originalLoanAmount"
      },
      {
        key: "Original Maximum Loan Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.originalMaximumLoanAmount"
      }
    ],
    formulaText: `
      =IF(
        Loan Structure = "Dutch",
        (Interest Rate * Original Maximum Loan Amount) / 12,
        IF(
          Loan Structure = "Non-Dutch",
          (Interest Rate * Initial Loan Amount) / 12,
          ""
        )
      )
    `
  },
  {
    label: "OOP Budget",
    path: "loanResults.loanResult.[loanId].loanFeatures.outOfPocketBudget",
    field: "outOfPocketBudget",
    type: "currency",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Total Budget Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.totalBudgetAmount"
      },
      {
        key: "Financed Budget Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath:
          "loanResults.loanResult.[loanId].loanEconomics.financedBudgetAmountCalculated"
      }
    ],
    formulaText: `=Total Budget Amount - Financed Budget Amount`
  },
  {
    label: "Stabilized Flag",
    path: "loanResults.loanResult.[loanId].loanCharacterisations.stabilizedFlag",
    field: "stabilizedFlag",
    type: "boolean",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Loan Purpose",
        fieldPath: "loanInfo.loanPurpose"
      },
      {
        key: "Total Budget Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.totalBudgetAmount"
      },
      {
        key: `Original "As Is" Appraisal Value`,
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath:
          "loanResults.loanResult.[loanId].loanEconomics.originalAsIsAppraisalValue"
      },
      {
        key: "Purchase Price",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath:
          "loanResults.loanResult.[loanId].toorakInterests.purchasePrice"
      }
    ],
    formulaText: `
      =IF(
        AND(
          Loan Purpose = "Purchase",
          Total Budget Amount <= 5% *
          MIN(
            Original "As Is" Appraisal Value,
            Purchase Price ( Only for Purchase Purpose )
          )
        ),
        "Stabilized",
        IF(
          AND(
            Loan Purpose <> "Purchase",
            Total Budget Amount <= 5% * Original "As Is" Appraisal Value
          ),
          "Stabilized",
          "Not Stabilized"
        )
      )
    `
  },
  {
    label: "Delayed Purchase Flag",
    path: "loanResults.loanResult.[loanId].loanCharacterisations.delayedPurchaseFlag",
    field: "delayedPurchaseFlag",
    type: "boolean",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Original Property Acquisition Date",
        formatter: MMMDDYYYY,
        fieldPath: "propertyinfo.propertyAcquisitionDate"
      },
      {
        key: "Origination Date",
        formatter: MMMDDYYYY,
        fieldPath: "loanInfo.originationDate"
      },
      {
        key: "Toorak Product",
        fieldPath: "loanInfo.toorakProduct"
      },
      {
        key: "Property Type",
        fieldPath: "propertyinfo.propertyType"
      }
    ],
    formulaText: `
      =IF(
        OR(
          AND(
            "Toorak Product" = "Bridge",
            DATEDIF(
              MIN("Original Property Acquisition Date", "Origination Date"),
              MAX("Original Property Acquisition Date", "Origination Date"),
              "m"
            ) < 6
          ),
          AND(
            "Toorak Product" = "GUC",
            DATEDIF(
              MIN("Original Property Acquisition Date", "Origination Date"),
              MAX("Original Property Acquisition Date", "Origination Date"),
              "m"
            ) < 24
          ),
          AND(
            "Property Type" = "multiFamily",
            DATEDIF(
              MIN("Original Property Acquisition Date", "Origination Date"),
              MAX("Original Property Acquisition Date", "Origination Date"),
              "m"
            ) < 3
          )
        ),
        TRUE,
        FALSE
      )
    `
  },
  {
    label: "Loan Structure",
    path: "loanResults.loanResult.[loanId].loanCharacterisations.loanStructureType",
    field: "loanStructureType",
    type: "text",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Loan Structure",
        fieldPath: "loanInfo.loanStructure"
      }
    ],
    formulaText: `
      =IF(
        Loan Structure = "Single Funding (With Rehab Escrow)",
        "Dutch",
        "Non-Dutch"
      )
    `
  },
  {
    label: "Financed Budget ($)",
    path: "loanResults.loanResult.[loanId].loanEconomics.financedBudgetAmountCalculated",
    field: "financedBudgetAmountCalculated",
    type: "currency",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Original Max Loan Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.cutOffDateMaximumLoanAmount"
      },
      {
        key: "Initial Loan Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.originalLoanAmount"
      }
    ],
    formulaText: `=Original Max Loan Amount - Initial Loan Amount`
  },
  {
    label: "Cross Collateralized (Yes/No)",
    path: "loanResults.loanResult.[loanId].loanFeatures.crossCollaterlization",
    field: "crossCollaterlization",
    type: "string",
    aliasKey: "selectedCross",
    rulesKey: "crossCollaterlization",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Number of Properties",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: ""
      }
    ],
    formulaText: `
      =IF(
        Number of Properties > 1,
        "Yes",
        "No"
      )
    `
  },
  {
    label: "Total Number of Borrowers",
    path: "loanResults.loanResult.[loanId].borrowerInfo.numberOfGuarantors",
    field: "numberOfGuarantors",
    aliasKey: "numberOfGuarantors",
    rulesKey: "numberOfGuarantors",
    type: "string",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Loan User Type",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: ""
      }
    ],
    formulaText: `= Total number of Individuals`
  },
    {
    label: "Original CLTV",
    path: "loanResults.loanResult.[loanId].loanFeatures.originalCltv",
    ttfInfoPath: "results.loanResult.[loanId].loanFeatures.originalCltv",
    field: "originalCltv",
    type: "percentage",
    skipRules: true,
    outputDataMadeInput: false
  },
  {
    label: "Original As Is LTV",
    path: "loanResults.loanResult.[loanId].loanFeatures.financedAsIsLtv",
    ttfInfoPath: "results.loanResult.[loanId].loanFeatures.financedAsIsLtv",
    field: "financedAsIsLtv",
    type: "percentage",
    skipRules: true,
    outputDataMadeInput: false,
    formulaVariables: [
      {
        key: "Original loan amount",
      },
      {
        key: "Down payment reserve"
      },
      {
        key: "Interest reserve"
      },
      {
        key: "Recent AS IS Appraisal Value"
      }
    ],
    formulaText: `
    = (
        Original Loan Amount
        - Down Payment Reserve
        - Interest Reserve
      )
      / Sum of Recent AS IS Appraisal Values of all Properties
    `
  },
  {
    label: "Total As Is LTV",
    path: "loanResults.loanResult.[loanId].loanFeatures.financedAsIsLtv",
    ttfInfoPath: "results.loanResult.[loanId].loanFeatures.financedAsIsLtv",
    field: "financedAsIsLtv",
    type: "percentage",
    skipRules: true,
    outputDataMadeInput: false,
    formulaVariables: [
      {
        key: "Original loan amount",
      },
      {
        key: "Down payment reserve"
      },
      {
        key: "Interest reserve"
      },
      {
        key: "Recent AS IS Appraisal Value"
      }
    ],
    formulaText: `
    = (
        Original Loan Amount
        - Down Payment Reserve
        - Interest Reserve
      )
      / Sum of Recent AS IS Appraisal Values of all Properties
    `
  },
    {
    label: "Original LTC",
    path: "loanResults.loanResult.[loanId].loanFeatures.originalLtc",
    ttfInfoPath: "results.loanResult.[loanId].loanFeatures.originalLtc",
    field: "originalLtc",
    type: "percentage",
    skipRules: true,
    outputDataMadeInput: false,
    formulaVariables: [
      {
        key: "Original loan amount",
      },
      {
        key: "Down payment reserve"
      },
      {
        key: "Interest reserve"
      },
      {
        key: "Cost Basis (Aggregate)"
      }
    ],
    formulaText: `
    = (
        Original loan amount
        - Down payment reserve
        - Interest reserve
      )
      / Sum of Cost Basis after Cost incurred of all Properties
    `
  },
  {
    label: "Original As Repaired LTV",
    path: "loanResults.loanResult.[loanId].loanFeatures.financedAsRepairedLtv",
    ttfInfoPath:
      "results.loanResult.[loanId].loanFeatures.financedAsRepairedLtv",
    field: "financedAsRepairedLtv",
    type: "percentage",
    skipRules: true,
    outputDataMadeInput: false,
    formulaVariables: [
      {
        key: "Original Max loan amount"
      },
      {
        key: "Down payment reserve"
      },
      {
        key: "Final As Repaired Value"
      }
    ],
    formulaText: `= (Original Max loan amount - Down payment reserve) / Sum of Final As Repaired Value`
  },
  {
    label: "Total As Repaired LTV",
    path: "loanResults.loanResult.[loanId].loanFeatures.financedAsRepairedLtv",
    ttfInfoPath:
      "results.loanResult.[loanId].loanFeatures.financedAsRepairedLtv",
    field: "financedAsRepairedLtv",
    type: "percentage",
    skipRules: true,
    outputDataMadeInput: false,
    formulaVariables: [
      {
        key: "Original Max loan amount"
      },
      {
        key: "Down payment reserve"
      },
      {
        key: "Final As Repaired Value"
      }
    ],
    formulaText: `= (Original Max loan amount - Down payment reserve) / Sum of Final As Repaired Value`
  },
  {
    label: "As-Repaired CLTV",
    path: "loanResults.loanResult.[loanId].loanFeatures.asRepairedCltv",
    ttfInfoPath: "results.loanResult.[loanId].loanFeatures.asRepairedCltv",
    field: "asRepairedCltv",
    type: "percentage",
    skipRules: true,
    outputDataMadeInput: false
  },
  {
    label: "Total As-Is CLTV",
    path: "loanResults.loanResult.[loanId].loanFeatures.totalAsIsCltv",
    ttfInfoPath: "results.loanResult.[loanId].loanFeatures.totalAsIsCltv",
    field: "totalAsIsCltv",
    type: "percentage",
    skipRules: true,
    outputDataMadeInput: false
  },
  {
    label: "Total As-Repaired CLTV",
    path: "loanResults.loanResult.[loanId].loanFeatures.totalAsRepairedCltv",
    ttfInfoPath: "results.loanResult.[loanId].loanFeatures.totalAsRepairedCltv",
    field: "totalAsRepairedCltv",
    type: "percentage",
    skipRules: true,
    outputDataMadeInput: false
  },
  // {
  //   label: "Financed As-Is Ltv",
  //   path: "loanResults.loanResult.[loanId].loanFeatures.financedAsIsLtv",
  //   ttfInfoPath: "results.loanResult.[loanId].loanFeatures.financedAsIsLtv",
  //   field: "financedAsIsLtv",
  //   type: "percentage",
  //   skipRules: true,
  //   outputDataMadeInput: false
  // },
  {
    label: "Original Term to Maturity (Months)",
    path: "loanResults.loanResult.[loanId].loanFeatures.originalTermToMaturity",
    field: "originalTermToMaturity",
    type: "string",
    skipRules: true,
    outputDataMadeInput: false,
    formulaVariables: [
      {
        key: "First Payment Date of Loan",
        formatter: MMMDDYYYY,
        fieldPath: "loanInfo.firstPaymentDateOfLoan"
      },
      {
        key: "Original Maturity Date",
        formatter: MMMDDYYYY,
        fieldPath: "loanInfo.originalMaturityDate"
      }
    ],
    formulaText: `
      = FLOOR(
        (
          Difference between First Payment Date of Loan
          and Original Maturity Date
        )
        / 30
        + 1
      )
    `
  },
  {
    label: "Original Interest Only Term",
    path: "loanResults.loanResult.[loanId].loanFeatures.originalTermToMaturity",
    field: "originalTermToMaturity",
    type: "string",
    values: armIndexTypes,
    skipRules: true,
    formulaVariables: [
      {
        key: "First Payment Date of Loan",
        formatter: MMMDDYYYY,
        fieldPath: "loanInfo.firstPaymentDateOfLoan"
      },
      {
        key: "Original Maturity Date",
        formatter: MMMDDYYYY,
        fieldPath: "loanInfo.originalMaturityDate"
      }
    ],
    formulaText: `
      = FLOOR(
        (
          Difference between First Payment Date of Loan
          and Original Maturity Date
        )
        / 30
        + 1
      )
    `
  },
  {
    label: "Customer Type",
    path: "loanResults.loanResult.[loanId].loanCharacterisations.customerType",
    ttfInfoPath:
      "results.loanResult.[loanId].loanCharacterisations.customerType",
    field: "customerType",
    type: "string",
    skipRules: true,
    outputDataMadeInput: false,
    formulaVariables: [
      {
        key: "PropertyType",
        formatter: (text: string) => text,
        fieldPath: "loanInfo.propertyType"
      },
      {
        key: "Experience",
        formatter: (text: string) => text,
        fieldPath: "loanResults.loanResult.[loanId].borrowerInfo.experience"
      },
    ],
    formulaText: `= IF (PropertyType == "Ground-Up" || PropertyType == "Multifamily") {
    if (Experience >= 3) {
        "Experienced Customer"
    }
    else {
        "New Customer"
    }
}
else {
    // Bridge 1-4 Family
    if (Experience >= 15) {
        "Ultra-Professional Customer"
    }
    else if (Experience >= 8 && Experience <= 14) {
        "Professional Customer"
    }
    else if (Experience >= 3 && Experience <= 7) {
        "Experienced Customer"
    }
    else if (Experience >= 1 && Experience <= 2) {
        "Novice Customer"
    }
    else {
        "New Customer"
    }
}

 `
  },
   {
    label: "Borrower Experience",
    path: "loanResults.loanResult.[loanId].borrowerInfo.experience",
    ttfInfoPath: "results.loanResult.[loanId].borrowerInfo.experience",
    field: "experience",
    type: "number",
    skipRules: true,
    outputDataMadeInput: false,
    formulaVariables: [
      {
        key: "Product Type",
      },
      {
        key: "0 to 3 Experience",
      },
      {
        key: "3 to 10 Experience",
      },
      {
        key: "GUC Experience",
      },
      {
        key: "Heavy Rehab Experience",
      }
    ],
    formulaText: `
      = IF (Product = "1-4 Family Bridge" || Product = "Multi Family") {
        0 to 3 Experience + (3-10 Experience / 2)
      } ELSE IF (Product = "Ground Up") {
        GUC Experience + Heavy Rehab Experience
      }
    `
  },
  {
    label: "Total Origination and Discount Points ($)",
    path: "loanResults.loanResult.[loanId].loanEconomics.totalOriginationAndDiscountPointsCurrency",
    field: "totalOriginationAndDiscountPointsCurrency",
    type: "currency",
    skipRules: true,
    formulaVariables: [
      {
        key: "Origination Fee",
        formatter: (text: string) => sanitizePercentage(text),
        fieldPath: ""
      },
      {
        key: "Discount Fee",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: ""
      }
    ],
    formulaText: `= Origination Fee + Discount Fee`
  },
  {
    label: "Rehab Type",
    path: "loanResults.loanResult.[loanId].loanCharacterisations.rehabType",
    field: "rehabType",
    type: "text",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Change in Use Case",
      },
      {
        key: "Toorak Product",
      },
      {
        key: "Post-Rehab Square Footage",
      },
      {
        key: "Pre-Rehab Square Footage", 
      },
      {
        key: "Property Type",
      },
      {
        key: "Total Budget Amount",
      },
      { 
        key: "Original As Is Appraisal Value",
      },
      {
        key: "Purchase Price",
      },
      {
        key: "Expansion",
      },
      {
        key: "Stabilized Flag",
      },
      {
        key: "Loan Purpose",
      },
      {
        key: "Original As Repaired Appraised Value",
      }
    ],
    formulaText: `IF(
         OR(
          [Change in Use Case] = "Y",
          [Toorak Product] = "Ground-Up",
                 AND(
              ( [Post-Rehab Square Footage] - [Pre-Rehab Square Footage] ) > 750,
              ( [Post-Rehab Square Footage] / [Pre-Rehab Square Footage] ) > 1.2
        ) 
    ),
      "Heavy Rehab",
         IF(
                 OR(
              [Property Type] = "Condo",
              [Property Type] = "SFR",
              [Property Type] = "Townhome",
              [Property Type] = "2-4 Unit" 
        ),
                 IF(
                         OR(
                  TotalBudgetAmount > 0.5 *
                MIN(
                    OriginalAsIsAppraisalValue,
                      PurchasePrice
                ),
                 ChangeInUseCase = "Yes",
                Expansion = "Yes" 
            ),
              "Heavy Rehab",
                         IF(
                  Stabilized Flag = "Not Stabilized",
                  "Light Rehab",
                  "" 
            ) 
        ),
                 IF(
                         OR(
                  [Property Type] = "Multifamily",
                  [Property Type] = "MixedUse" 
            ),
                         IF(
                  [Loan Purpose] = "Purchase",
                                 IF(
                                         OR(
                          ( 3 *                              MIN(
                                  [Original As Is Appraisal Value],
                                  [Purchase Price]
                            ) ) <= [Original As Repaired Appraised Value],
                          ( 0.5 *                              MIN(
                                  [Original As Is Appraisal Value],
                                  [Purchase Price]
                            ) ) < [Total Budget Amount]
                    ),
                      "Heavy Rehab",
                      "Light Rehab" 
                ),
                                 IF(
                      ( 0.5 * [Original As Is Appraisal Value] ) < [Total Budget Amount],
                      "Heavy Rehab",
                      "Light Rehab" 
                ) 
            ),
              "N/A" 
        ) 
    ) 
)`
  },
  {
    label: "DSCR",
    path: "loanResults.loanResult.[loanId].loanEconomics.dscrCalculation",
    field: "dscrCalculation",
    type: "text",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Toorak Product",
      },
      {
        key: "Stabilized Flag",
      },
      {
        key: "Gross Potential Rent",
      },
      {
        key: "Annual Insurance",
      },
      {
        key: "Annual Property Taxes",
      },
      {
        key: "Annual HOA Fee",
      }

    ],
    formulaText: `
      = IF (
        Toorak Product = "Bridge" &&
        Stabilized Flag = "Stabilized"
      ) {
        Sum of Gross Potential Rent
        / (
          Annualized IO Payments
          + Sum of Insurance
          + Sum of Annual Property Taxes
          + Sum of Annual HOA Fee
        )
      } ELSE {
        "N/A"
      }
    `
  },
  {
    label: "Underwritten NOI/NCF ($)",
    path: "loanResults.loanResult.[loanId].multiFamilyMixedUse.underwrittenNoiorNof",
    field: "underwrittenNoiorNof",
    type: "currency",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [],
    formulaText: ``
  },
  {
    label: "Amortization Term",
    path: "loanResults.loanResult.[loanId].loanFeatures.ioTerm",
    field: "ioTerm",
    type: "text",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "First Payment Date of Loan",
        formatter: MMMDDYYYY,
        fieldPath: "loanInfo.firstPaymentDateOfLoan"
      },
      {
        key: "Original Maturity Date",
        formatter: MMMDDYYYY,
        fieldPath: "loanInfo.originalMaturityDate"
      }
    ],
    formulaText: `
      = FLOOR(
        (
          Difference between First Payment Date of Loan
          and Original Maturity Date
        )
        / 30
        + 1
      )
    `
  },
  {
    label: "Foreign National",
    path: "loanResults.loanResult.[loanId].borrowerInfo.isForeignNational",
    field: "isForeignNational",
    type: "text",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [],
    formulaText: `
      = IF (Primary Borrower / Primary Guarantor = Is Foreign National) {
        Y
      } ELSE {
        N
      }
    `
  },
  {
    label: "Cost Basis (Aggregate)",
    path: "propertyEconomics.costBasis",
    ttfInfoPath: "propertyEconomics.costBasis",
    field: "sumOfCostBasis",
    type: "number",
    skipRules: true,
    outputDataMadeInput: false,
    formulaVariables: [
      {
        key: "Cost Basis",
        formatter: (text: string) => text,
        fieldPath: ""
      }
    ],
    formulaText: `= Sum of all Cost Basis`
  },
  {
    label: "Purchase Price (Aggregate)",
    path: "propertyEconomics.purchasePrice",
    ttfInfoPath: "propertyEconomics.purchasePrice",
    field: "sumOfPurchasePrice",
    type: "number",
    skipRules: true,
    outputDataMadeInput: false,
    formulaVariables: [
      {
        key: "Purchase Price",
        formatter: (text: string) => text,
        fieldPath: ""
      }
    ],
    formulaText: `= Sum of all Purchase Price`
  },
  {
    label: "Percentage of Down Payment from Borrower Own Funds",
    path: "loanResults.loanResult.[loanId].loanEconomics.percentageOfDownPaymentFromBorrowerOwnFunds",
    field: "percentageOfDownPaymentFromBorrowerOwnFunds",
    type: "currency",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Loan Purpose",
        fieldPath: "loanInfo.loanPurpose"
      },
    ],
    formulaText: `
      = IF (Loan Purpose = "Purchase") {
        1
      } ELSE {
        0
      }
    `
  },
  {
    label: "Cash Out Flag",
    path: "loanResults.loanResult.[loanId].loanCharacterisations.cashOutFlag",
    field: "cashOutFlag",
    type: "boolean",
    disableAfterApproved: true,
    resultPath: "loanResult",
    formulaVariables: [
      {
        key: "Cash Out Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.cashOutAmount"
      },
      {
        key: "Original Loan Amount",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: "loanEconomics.originalLoanAmount"
      }
    ],
    formulaText: `
      =IF(
        Cash Out Amount / Original Loan Amount > 2%,
        "Cash Out",
        "No Cash Out"
      )
    `
  },
];

export const DSCRDataReconCalculatedFields = [
    {
    label: "Borrower Experience",
    path: "loanResults.loanResult.[loanId].borrowerInfo.experience",
    ttfInfoPath: "results.loanResult.[loanId].borrowerInfo.experience",
    field: "experience",
    type: "number",
    skipRules: true,
    outputDataMadeInput: false,
    formulaVariables: [
      {
        key: "Product Type",
      },
      {
        key: "0 to 3 Experience",
      },
      {
        key: "3 to 10 Experience",
      },
      {
        key: "GUC Experience",
      },
      {
        key: "Heavy Rehab Experience",
      }
    ],
    formulaText: `
      = IF (Product = "1-4 Family Bridge" || Product = "Multi Family") {
        0 to 3 Experience + (3-10 Experience / 2)
      } ELSE IF (Product = "Ground Up") {
        GUC Experience + Heavy Rehab Experience
      }
    `
  },
  {
    label: "Total Origination and Discount Points ($)",
    path: "loanResults.loanResult.[loanId].loanEconomics.totalOriginationAndDiscountPointsCurrency",
    field: "totalOriginationAndDiscountPointsCurrency",
    type: "currency",
    skipRules: true,
    formulaVariables: [
      {
        key: "Origination Fee",
        formatter: (text: string) => sanitizePercentage(text),
        fieldPath: ""
      },
      {
        key: "Discount Fee",
        formatter: (text: string) => sanitizeCurrency(text),
        fieldPath: ""
      }
    ],
    formulaText: `= Origination Fee + Discount Fee`
  }
];

export const InternalLoanDataReconColumns = [
  {
    id: "label",
    showSort: true,
    title: "Data Field",
    isVisible: () => true,
    width: "16%"
  },
  {
    id: "sheetName",
    showSort: true,
    title: "Sheet Name",
    isVisible: () => true,
    width: "16%"
  },
  {
    id: "columnName",
    showSort: true,
    title: "Column Name",
    isVisible: () => true,
    width: "16%"
  },
  {
    id: "loanInfo",
    showSort: true,
    title: "Current Info",
    isVisible: () => true,
    width: "16%"
  },
  // {
  //   id: "ttfInfo",
  //   showSort: true,
  //   title: "Document Info",
  //   isVisible: (data: any) => true,
  //   width: "18%"
  // },
  {
    id: "diligenceInfo",
    showSort: true,
    title: "TPR Info",
    isVisible: () => true,
    width: "16%"
  },
  {
    id: "documentInfo",
    showSort: true,
    title: "Reconciled Data",
    isVisible: (data: any) => data?.tab !== "calculatedFields",
    width: "16%"
  },
  {
    id: "doesDataMatch",
    showSort: true,
    title: "Does Data Match ?",
    isVisible: (data: any) => data?.tab === "calculatedFields",
    width: "16%"
  },
  {
    id: "comment",
    showSort: true,
    title: "",
    isVisible: () => true,
    width: "4%"
  }
];

export const CommonDataReconColumns = [
  {
    id: "label",
    showSort: true,
    title: "Data Field",
    isVisible: () => true,
    width: "25%"
  },
  {
    id: "loanInfo",
    showSort: true,
    title: "Current Info",
    isVisible: () => true,
    width: "18%"
  },
  {
    id: "diligenceInfo",
    showSort: true,
    title: "TPR Info",
    isVisible: () => true,
    width: "18%"
  },
  {
    id: "servicerInfo",
    showSort: true,
    title: "Servicer Info",
    isVisible: (data: any) => true,
    width: "17%"
  },
  {
    id: "wellsInfo",
    showSort: true,
    title: "Wells Info",
    isVisible: (data: any) => true,
    width: "17%"
  },
  {
    id: "comment",
    showSort: true,
    title: "",
    isVisible: () => true,
    width: "4%"
  }
];

export const NewDataReconLoanFields = [
  {
    label: "Originator",
    path: "sellerPartyInfo.accountName",
    field: "originator",
    type: "string",
    values: armIndexTypes,
    skipRules: true
  },
  {
    label: "Loan Number",
    path: "loanDetailId.loanId",
    field: "loanId",
    type: "string",
    values: armIndexTypes,
    skipRules: true
  },
  {
    label: "Lien Position",
    path: "loanInfo.lienPosition",
    field: "lienPosition",
    rulesKey: "lien_position",
    type: "string",
    skipRules: true
  },
  {
    label: "Total Origination and Discount Points ($)",
    path: "loanResults.loanResult.[loanId].loanEconomics.totalOriginationAndDiscountPoints",
    field: "totalOriginationAndDiscountPoints",
    type: "currency",
    skipRules: true
  },
  {
    label: "Escrow Indicator",
    path: "loanInfo.escrowIndicator",
    field: "escrowIndicator",
    rulesKey: "escrow_indicator",
    type: "string",
    skipRules: true
  },
  {
    label: "Junior Lien Balance",
    path: "loanInfo.juniorLienBalance",
    field: "juniorLienBalance",
    type: "currency",
    skipRules: true
  },
  {
    label: "ARM Look Back Days",
    path: "loanEconomics.armLookBackDays",
    field: "armLookBackDays",
    type: "number",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "ARM Round Flag",
    path: "loanEconomics.armRoundFlag",
    field: "armRoundFlag",
    type: "dropdown",
    values: yesNoDropdown,
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Arm Rounding Factor",
    path: "loanEconomics.armRoundingFactor",
    field: "armRoundingFactor",
    type: "number",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Initial Periodic Cap (Change Up) (%)",
    path: "loanEconomics.initialInterestRateUp",
    field: "initialInterestRateUp",
    type: "percentage",
    disableAfterApproved: true,
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Initial Periodic Cap (Change Down) (%)",
    path: "loanEconomics.initialInterestRateDown",
    field: "initialInterestRateDown",
    type: "percentage",
    disableAfterApproved: true,
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Subsequent Periodic Cap (Change Up) (%)",
    path: "loanEconomics.subsequentInterestRateUp",
    field: "subsequentInterestRateUp",
    type: "percentage",
    disableAfterApproved: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Subsequent Periodic Cap (Change Down) (%)",
    path: "loanEconomics.subsequentInterestRateDown",
    field: "subsequentInterestRateDown",
    type: "percentage",
    disableAfterApproved: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Lifetime Max Rate (%)",
    path: "loanEconomics.lifetimeMaxRate",
    field: "lifetimeMaxRate",
    type: "percentage",
    disableAfterApproved: true,
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Lifetime Min Rate (%)",
    path: "loanEconomics.lifetimeMinRate",
    field: "lifetimeMinRate",
    type: "percentage",
    disableAfterApproved: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  {
    label: "Prepayment Penalty Total Term (Months)",
    path: "loanEconomics.prepaymentPenaltyMonths",
    field: "prepaymentPenaltyMonths",
    type: "number"
  },
  {
    label: "Prepayment Penalty Calculation Type",
    path: "loanEconomics.prepaymentPenaltyCalculationType",
    field: "prepaymentPenaltyCalculationType",
    type: "number"
  },
  {
    label: "Prepayment Penalty Type",
    path: "loanEconomics.prepayPenaltyType",
    field: "prepayPenaltyType",
    type: "dropdown",
    disableAfterApproved: true,
    values: prepaymentPenaltyTypeDropDown
  },
  {
    label: "Prepayment Penalty Hard Term",
    path: "loanEconomics.prepaymentPenaltyHardTerm",
    field: "prepaymentPenaltyHardTerm",
    type: "number"
  },
  {
    label: "Liquid/Cash Reserves",
    path: "loanEconomics.liquidCashReserves",
    field: "liquidCashReserves",
    type: "currency"
  },
  {
    label: "Fully Indexed Rate",
    path: "loanEconomics.fullyIndexedRate",
    field: "fullyIndexedRate",
    type: "percentage",
    skipRules: true,
    hidden: (loanDetails: any, view: string) =>
      loanDetails?.loanEconomics?.rateType !== "Adjustable"
  },
  // {
  //   label: "Percentage of Down Payment from Borrower Own Funds",
  //   path: "loanEconomics.percentageOfDownPaymentFromBorrowerOwnFunds",
  //   field: "percentageOfDownPaymentFromBorrowerOwnFunds",
  //   type: "currency"
  // },
  // {  //added in Bridge loan Fields
  //   label: "Toorak Product",
  //   path: "loanInfo.toorakProduct",
  //   field: "toorakProduct",
  //   aliasKey: "selectedToorakProduct",
  //   rulesKey: "toorakProduct",
  //   type: "dropdown",
  //   values: toorakProductDropDown
  // },
  {
    label: "Number Of Properties",
    path: "loanInfo.noOfProperties",
    field: "noOfProperties",
    aliasKey: "numberOfProperties",
    rulesKey: "noOfProperties",
    type: "number",
    disableAfterApproved: true
  },
  {
    label: "Business Purpose Occupancy",
    path: "loanEconomics.businessPurposeOccupancy",
    field: "businessPurposeOccupancy",
    rulesKey: "occupancy",
    type: "yesnodropdown",
    disableAfterApproved: true,
    values: yesNoDropdown
  },
 {
    label: "Max Loan Amount",
    path: "loanEconomics.originalMaximumLoanAmount",
    field: "originalMaximumLoanAmount",
    aliasKey: "maxLoanAmount",
    rulesKey: "originalMaximumLoanAmount",
    disableAfterApproved: true,
    type: "currency"
  },
];

export const NewDataReconUserFields = [
  {
    label: "FICO Model Used",
    path: "customer.ficoModelUsed",
    field: "ficoModelUsed",
    type: "string",
    borrowerAliasKey: "ficoModelUsed",
    guarantorAliasKey: "ficoModelUsed",
    partyType: "person",
  },
   {
    label: "Most Recent FICO Method",
    path: "customer.mostRecentFicoMethod",
    field: "mostRecentFicoMethod",
    type: "string",
    borrowerAliasKey: "mostRecentFicoMethod",
    guarantorAliasKey: "mostRecentFicoMethod",
    partyType: "person",
  },
   {
    label: "Borrower Type",
    path: "customer.partyType",
    field: "partyType",
    type: "string",
    borrowerAliasKey: "partyType",
    guarantorAliasKey: undefined
  },
  // {
  //   label: "Months Bankruptcy",
  //   path: "customer.lastBkMonths",
  //   field: "lastBkMonths",
  //   type: "number"
  // },
  // {
  //   label: "Months Foreclosure",
  //   path: "customer.lastFcMonths",
  //   field: "lastFcMonths",
  //   type: "number"
  // },
  {
    label: "Income Verification Level",
    path: "customer.borrowerIncomeVerificationLevel",
    field: "borrowerIncomeVerificationLevel",
    type: "number",
    borrowerAliasKey: "borrowerIncomeVerificationLevel",
    guarantorAliasKey: "borrowerIncomeVerificationLevel",
    partyType: "person",
  },
  // {
  //   label: "Co-borrower Income Verification",
  //   path: "customer.coBorrowerIncomeVerification",
  //   field: "coBorrowerIncomeVerification",
  //   type: "number",
  //   borrowerAliasKey: "coBorrowerIncomeVerification",
  //   guarantorAliasKey: "coBorrowerIncomeVerification",
  // },
  {
    label: "Employment Verification",
    path: "customer.borrowerEmploymentVerification",
    field: "borrowerEmploymentVerification",
    type: "number",
    borrowerAliasKey: "borrowerEmploymentVerification",
    guarantorAliasKey: "borrowerEmploymentVerification",
    partyType: "person",
  },
  // {
  //   label: "Co-borrower Employment Verification",
  //   path: "customer.coBorrowerEmploymentVerification",
  //   field: "coBorrowerEmploymentVerification",
  //   type: "number",
  //   borrowerAliasKey: "coBorrowerEmploymentVerification",
  //   guarantorAliasKey: "coBorrowerEmploymentVerification",
  // },
  {
    label: "Asset Verification",
    path: "customer.borrowerAssetVerification",
    field: "borrowerAssetVerification",
    rulesKey: "borrower_asset_verification",
    type: "number",
    borrowerAliasKey: "borrowerAssetVerification",
    guarantorAliasKey: "borrowerAssetVerification",
    partyType: "person",
  },
  // {
  //   label: "Co-borrower Asset Verification",
  //   path: "customer.coBorrowerAssetVerification",
  //   field: "coBorrowerAssetVerification",
  //   type: "number",
  //   borrowerAliasKey: "coBorrowerAssetVerification",
  //   guarantorAliasKey: "coBorrowerAssetVerification",
  // },
  {
    label: "Qualification Method",
    path: "customer.qualificationMethod",
    field: "qualificationMethod",
    type: "number",
    borrowerAliasKey: "qualificationMethod",
    guarantorAliasKey: "qualificationMethod",
    partyType: "person",
  },
  // {
  //   label: "FICO Equifinax",
  //   path: "customer.creditInformation.Equifax.creditFirm",
  //   auditPath: "customer.creditInformation.[creditInfoId].creditFirm[Equifax]",
  //   field: "Equifax",
  //   borrowerAliasKey: "Equifax",
  //   guarantorAliasKey: "Equifax",
  //   type: "creditscore",
  //   disableAfterApproved: true,
  //   skipRules: false,
  //   customLabel: true,
  //   partyType: "person"
  // },
  // {
  //   label: "FICO Experian",
  //   path: "customer.creditInformation.Experian.creditFirm",
  //   auditPath: "customer.creditInformation.[creditInfoId].creditFirm[Experian]",
  //   field: "Experian",
  //   borrowerAliasKey: "Experian",
  //   guarantorAliasKey: "Experian",
  //   type: "creditscore",
  //   disableAfterApproved: true,
  //   skipRules: false,
  //   customLabel: true,
  //   partyType: "person"
  // },
  // {
  //   label: "Primary Wage Earner Original FICO: TransUnion",
  //   path: "customer.creditInformation.TransUnion.creditFirm",
  //   auditPath: "customer.creditInformation.[creditInfoId].creditFirm[TransUnion]",
  //   field: "TransUnion",
  //   borrowerAliasKey: "TransUnion",
  //   guarantorAliasKey: "TransUnion",
  //   type: "creditscore",
  //   disableAfterApproved: true,
  //   skipRules: false,
  //   customLabel: true,
  //   partyType: "person"
  // },
  // {
  //   label: "Secondary Wage Earner Original FICO: Equifax",
  //   path: "customer.creditInformation.Equifax.creditFirm",
  //   auditPath: "customer.creditInformation.[creditInfoId].creditFirm[Equifax]",
  //   field: "secondaryWageEarnerOriginalFicoEquifax",
  //   type: "number",
  //   borrowerAliasKey: "secondaryWageEarner",
  //   guarantorAliasKey: "secondaryWageEarner",
  // },
  // {
  //   label: "Secondary Wage Earner Original FICO: Experian",
  //   path: "customer.creditInformation.Experian.creditFirm",
  //   auditPath: "customer.creditInformation.[creditInfoId].creditFirm[Experian]",
  //   field: "secondaryWageEarnerOriginalFicoExperian",
  //   type: "number",
  //   borrowerAliasKey: "secondaryWageEarner",
  //   guarantorAliasKey: "secondaryWageEarner",
  // },
  // {
  //   label: "Secondary Wage Earner Original FICO: TransUnion",
  //   path: "customer.creditInformation.TransUnion.creditFirm",
  //   auditPath: "customer.creditInformation.[creditInfoId].creditFirm[TransUnion]",
  //   field: "secondaryWageEarnerOriginalFicoTransunion",
  //   type: "number",
  //   borrowerAliasKey: "secondaryWageEarner",
  //   guarantorAliasKey: "secondaryWageEarner",
  // },
];

export const NewDataReconPropertiesFields = [
  {
    label: "Sales Price ($)",
    path: "propertiesResults.loanEconomics.salesPrice",
    field: "salesPrice",
    type: "currency",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false,
    isReadOnlyField: true,
    formulaVariables: [
      {
        key: "Loan Purpose",
        fieldPath: "loanInfo.loanPurpose"
      },
      {
        key: "Purchase Price",
        fieldPath: "loanEconomics.purchasePrice"
      },
    ],
    formulaText: `
      = IF (Loan Purpose = "Purchase") {
        Purchase Price
      } ELSE {
        0
      }
    `
  },
  {
    label: "Most Recent Property Value",
    path: "propertiesResults.loanFeatures.asIsValueForCalculation",
    field: "asIsValueForCalculation",
    type: "currency",
    disableAfterApproved: true,
    isReadOnlyField: true,
    // formulaVariables: [],
    // formulaText: ``
  },
  {
    label: "Most Recent Property Valuation Type",
    path: "propertiesResults.loanFeatures.asIsValueSource",
    field: "asIsValueSource",
    type: "string",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  {
    label: "Most Recent Property Valuation Date",
    path: "propertiesResults.loanFeatures.valuationDateForCalculation",
    field: "valuationDateForCalculation",
    type: "date",
    isReadOnlyField: true,
    // formulaVariables: [],
    // formulaText: ``
  },
  // { // Added in Bridge Properties fields
  //   label: "Number of Units",
  //   path: "propertyinfo.propertyUnits",
  //   field: "propertyUnits",
  //   type: "number",
  //   disableAfterApproved: true,
  //   values: undefined,
  //   skipRules: false
  // },
  // {
  //   label: "Underwritten NOI/NCF ($)",
  //   path: "propertiesResults.multiFamilyMixedUse.underwrittenNoiorNof",
  //   field: "underwrittenNoiorNof",
  //   type: "currency",
  //   disableAfterApproved: true,
  //   values: undefined,
  //   skipRules: false
  // },
  {
    label: "House Canary Value Median",
    path: "propertiesResults.multiFamilyMixedUse.hcValueMedian",
    field: "hcValueMedian",
    type: "currency",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  {
    label: "Original Automated Valuation Model(AVM) Model Name",
    path: "propertiesResults.loanFeatures.originalAvmName",
    field: "originalAvmName",
    type: "string",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  {
    label: "Original AVM Confidence Score",
    path: "propertiesResults.loanFeatures.originalAvmConfidenceScore",
    field: "originalAvmConfidenceScore",
    type: "string",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  {
    label: "Most Recent AVM Model Name",
    path: "propertiesResults.loanFeatures.mostRecentAvmName",
    field: "mostRecentAvmName",
    type: "string",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  {
    label: "Most Recent AVM Confidence Score",
    path: "propertiesResults.loanFeatures.mostRecentAvmConfidenceScore",
    field: "mostRecentAvmConfidenceScore",
    type: "string",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  // {
  //   label: "Original Valuation Source",
  //   path: "propertiesResults.loanFeatures.originalAsIsValueSource",
  //   field: "originalAsIsValueSource",
  //   type: "string",
  //   disableAfterApproved: true,
  //   values: undefined,
  //   skipRules: false
  // },
  // {
  //   label: "Original As Is Appraisal Value",
  //   path: "propertiesResults.loanFeatures.originalAsIsValueForCalculation",
  //   field: "originalAsIsValueForCalculation",
  //   type: "currency",
  //   disableAfterApproved: true,
  //   values: undefined,
  //   skipRules: false
  // },
  {
    label: "Original As Is Valuation Source",
    path: "propertiesResults.loanFeatures.originalAsIsValueSource",
    field: "originalAsIsValueSource",
    type: "string",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  {
    label: "Original As Is Value ($)",
    path: "propertiesResults.loanFeatures.originalAsIsValueForCalculation",
    field: "originalAsIsValueForCalculation",
    type: "currency",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  {
    label: "Original As Is Valuation Date",
    path: "propertiesResults.loanFeatures.originalValuationDateForCalculation",
    field: "originalValuationDateForCalculation",
    type: "date",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  {
    label: "Original As Repaired Valuation Source",
    path: "propertiesResults.loanFeatures.originalArvValueSource",
    field: "originalArvValueSource",
    type: "string",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  {
    label: "Original As Repaired Value (ARV) ($)",
    path: "propertiesResults.loanFeatures.originalArvValueForCalculation",
    field: "originalArvValueForCalculation",
    type: "currency",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  {
    label: "Original As Repaired Valuation Date",
    path: "propertiesResults.loanFeatures.originalArvValuationDate",
    field: "originalArvValuationDate",
    type: "date",
    disableAfterApproved: true,
    values: undefined,
    skipRules: false
  },
  // {
  //   label: "Original ARV Valuation Source",
  //   path: "propertiesResults.loanFeatures.arvValueSource",
  //   field: "arvValueSource",
  //   type: "string",
  //   disableAfterApproved: true,
  //   values: undefined,
  //   skipRules: false
  // },
   
];

export const ASFSheetLoanFields = [
  "armIndex",
  "cashOutAmount",
  "downPaymentReserve",
  "financedInterestReserve",
  "grossArmMargin",
  "interestRateAsOfCutOffDate",
  "originalMaximumLoanAmount",
  "rateType",
  "totalBudgetAmount",
  "firstPaymentDateOfLoan",
  "loanPurpose",
  "loanStructure",
  "originalMaturityDate",
  "originationDate",
  // "experience",
  // "businessPurposeOccupancy",
  // "escrowIndicator",
  "juniorLienBalance",
  "lienPosition",
  // "liquidCashReserves",
  "loanId",
  "accountName",
  // "percentageOfDownPaymentFromBorrowerOwnFunds",
  "prepayPenaltyType",
  "prepaymentPenaltyCalculationType",
  "prepaymentPenaltyHardTerm",
  "prepaymentPenaltyMonths",
  "toorakProduct",
  // "totalOriginationAndDiscountPointsCurrency",

  "originalLoanAmount",
  "originator",
  "borrowerLiquidity",

  "discountPointAmount",
  "originationFeeHUD"
]

export const ASFSheetUserFields = [
  "borrowerAssetVerification",
  "borrowerEmploymentVerification",
  "ficoModelUsed",
  "borrowerIncomeVerificationLevel",
  "qualificationMethod",
  
  // "foreignNationalString",
  "lastBkMonths",
  "lastFcMonths",
  "originalCreditScoreMedian",
  "originalCreditScoreReportDate",
  // "partyType",
  "Equifax",
  "Experian",
  "TransUnion",

  "accountName",
  "firstName",
  // "middleName",
  "lastName",
  // "eiNumber",
  // "ssNumber"
  "mostRecentFicoMethod",
  "lastBkDate",
  "lastFcDate"
]

export const ASFSheetPropertiesFields = [
  // "recentPropertyValuationDate",
  "asIsValueSource",
  "asIsValueForCalculation",

  "appraisalArvValue",
  "propertyValuationType",   //DSCR
  "originalAsIsAppraisalValue",
  "city",
  "valuationDateForCalculation",
  "postalCode",
  "propertyType",
  "propertyUnits",
  // "purchasePrice",
  "salesPrice",
  "state",
  // "costBasis",
  "originalAsIsValueSource",
  "originalAsIsValueForCalculation",
  "originalValuationDateForCalculation",
  "originalArvValueForCalculation",

  "addressLine1",
  "appraisalReportedNoiNcf",
  "verifiedCostsAndImprovements",
  // "costBasisCalculated"
]

export const ASFSheetCalculatedFields = [
  "stabilizedFlag",
  "crossCollaterlization",
  "delayedPurchaseFlag",
  "loanStructureType",
  "outOfPocketBudget",
  "financedBudgetAmountCalculated",
  // "numberOfBorrowers",
  // "originalAsRepairedLtv",
  "financedAsRepairedLtv",
  "originalAsIsRepairedLtv",
  "originalLtc",
  // "originalAsIsLtv",
  "financedAsIsLtv",
  "originalTermToMaturity",
  "customerType",
  "experience",
  "totalOriginationAndDiscountPointsCurrency",

  "rehabType",
  "dscrCalculation",
  "underwrittenNoiorNof",
  "ioTerm",
  "isForeignNational",

  "sumOfCostBasis",
  "numberOfGuarantors", // replaced numberOfBorrowers key
  "sumOfPurchasePrice",

  "percentageOfDownPaymentFromBorrowerOwnFunds",
  "cashOutFlag"
]

export const dscrAdjustableARMFields = [ 
  "armType",
  "armIndex", 
  "grossArmMargin",
  "initialRateAdjustmentDate",
  "initialPayAdjustmentDate", 
  "initialPeriodicCap",
  "subsequentPeriodicCap",
  "lifeRateCap",
  "lifeTimeFloor",
  "lifeTimeCap"
]

export const nonMandatoryFields = [
  "Equifax",
  "Experian",
  "TransUnion",
  "lastBkMonths",
  "lastFcMonths",
  "lastBkDate",
  "lastFcDate"
]